import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Box,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Avatar,
  IconButton,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  FormControlLabel,
  TablePagination,
  InputBase,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  CircularProgress,
  Skeleton,useTheme,
} from '@mui/material';
import {
  Block,
  CheckCircle,
  Edit,
  Add,
  Settings,
  Search,
  PersonAdd,
  PersonRemove,
  Delete,
  Clear,
  Security,
  ToggleOff,
  Warning,
  Inventory,
  Visibility,
  VisibilityOff,
  People,
  Store,
  Work,
  Campaign,
  ShoppingBag
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import { adminService } from '../services/adminService';
import { subscriptionService } from '../services/subscriptionService';
import categorieService from '../services/categorieService';
import UserModal from '../components/admin/UserModal';
import BoutiqueModal from '../components/admin/BoutiqueModal';
import ProductModal from '../components/admin/ProductModal';
import AdModal from '../components/admin/AdModal';
import SubscriptionPlanModal from '../components/admin/SubscriptionPlanModal';
import SubscriptionModal from '../components/admin/SubscriptionModal';
import CategoryModal from '../components/admin/CategoryModal';
import ServiceModal from '../components/admin/ServiceModal';
import CategorieServiceModal from '../components/admin/CategorieServiceModal';
import ConfirmationModal from '../components/admin/ConfirmationModal';
import PlatformSettingsModal from '../components/admin/PlatformSettingsModal';
import SecurityLogs from '../components/admin/SecurityLogs';
import Notification from '../components/Notification';

import api from '../services/api';

const Admin = () => {
  const { user } = useAuth();
  const theme=useTheme();
  const { settings, loadSettings } = useSettings();
  const [activeTab, setActiveTab] = useState(0);
  const [users, setUsers] = useState([]);
  const [boutiques, setBoutiques] = useState([]);
  const [products, setProducts] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [ads, setAds] = useState([]);
  const [services, setServices] = useState([]);
  const [categorieServices, setCategorieServices] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [pendingReviewsCount, setPendingReviewsCount] = useState(0);
  const [pendingProductsCount, setPendingProductsCount] = useState(0);
  const [pendingBoutiquesCount, setPendingBoutiquesCount] = useState(0);
  const [pendingSubscriptionsCount, setPendingSubscriptionsCount] = useState(0);
  const [showStatistics, setShowStatistics] = useState(false);

  // États pour la gestion des approbations
  const [approvalSettings, setApprovalSettings] = useState({
    products: true,
    boutiques: true,
    reviews: true,
    users: true
  });

  // États pour les notifications
  const [notification, setNotification] = useState({ message: '', type: 'success' });

  // États pour les filtres de recherche
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [userSearchInput, setUserSearchInput] = useState(''); // Valeur temporaire dans le champ
  const [userRoleFilter, setUserRoleFilter] = useState(''); // Tous, ADMIN, VENDOR, USER
  const [userIsBlockedFilter, setUserIsBlockedFilter] = useState(''); // Tous, true, false
  const [userIsApprovedFilter, setUserIsApprovedFilter] = useState(''); // Tous, true, false
  const [userIsEmailVerifiedFilter, setUserIsEmailVerifiedFilter] = useState(''); // Tous, true, false
  const [userSortOrder, setUserSortOrder] = useState('newest'); // newest, oldest
  const [boutiqueSearchTerm, setBoutiqueSearchTerm] = useState('');
  const [boutiqueSearchInput, setBoutiqueSearchInput] = useState(''); // Valeur temporaire dans le champ
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [productSearchInput, setProductSearchInput] = useState(''); // Valeur temporaire dans le champ
  const [productIsActiveFilter, setProductIsActiveFilter] = useState(''); // Tous, true, false
  const [productIsAvailableFilter, setProductIsAvailableFilter] = useState(''); // Tous, true, false
  const [adSearchTerm, setAdSearchTerm] = useState('');
  const [adSearchInput, setAdSearchInput] = useState(''); // Valeur temporaire dans le champ
  const [subscriptionPlanSearchTerm, setSubscriptionPlanSearchTerm] = useState('');
  const [subscriptionPlanSearchInput, setSubscriptionPlanSearchInput] = useState('');
  const [subscriptionSearchTerm, setSubscriptionSearchTerm] = useState('');
  const [subscriptionSearchInput, setSubscriptionSearchInput] = useState('');
  const [serviceSearchTerm, setServiceSearchTerm] = useState('');
  const [serviceSearchInput, setServiceSearchInput] = useState('');
  const [categorieServiceSearchTerm, setCategorieServiceSearchTerm] = useState('');
  const [categorieServiceSearchInput, setCategorieServiceSearchInput] = useState('');

  // États pour la pagination
  const [userPage, setUserPage] = useState(0);
  const [userRowsPerPage, setUserRowsPerPage] = useState(10);
  const [boutiquePage, setBoutiquePage] = useState(0);
  const [boutiqueRowsPerPage, setBoutiqueRowsPerPage] = useState(10);
  const [productPage, setProductPage] = useState(0);
  const [productRowsPerPage, setProductRowsPerPage] = useState(10);
  const [adPage, setAdPage] = useState(0);
  const [adRowsPerPage, setAdRowsPerPage] = useState(10);
  const [subscriptionPlanPage, setSubscriptionPlanPage] = useState(0);
  const [subscriptionPlanRowsPerPage, setSubscriptionPlanRowsPerPage] = useState(10);
  const [subscriptionPlanTotal, setSubscriptionPlanTotal] = useState(0);
  const [subscriptionPage, setSubscriptionPage] = useState(0);
  const [subscriptionRowsPerPage, setSubscriptionRowsPerPage] = useState(10);
  const [subscriptionTotal, setSubscriptionTotal] = useState(0);
  const [servicePage, setServicePage] = useState(0);
  const [serviceRowsPerPage, setServiceRowsPerPage] = useState(10);
  const [serviceTotal, setServiceTotal] = useState(0);
  const [reviewPage, setReviewPage] = useState(0);
  const [reviewRowsPerPage, setReviewRowsPerPage] = useState(10);
  const [reviewTotal, setReviewTotal] = useState(0);
  const [reviewSearchTerm, setReviewSearchTerm] = useState('');
  const [reviewSearchInput, setReviewSearchInput] = useState('');
  const [reviewIsActiveFilter, setReviewIsActiveFilter] = useState(''); // Tous, true, false
  const [reviewTypeFilter, setReviewTypeFilter] = useState(''); // Tous, PRODUCT, BOUTIQUE

  // États pour les données filtrées (pour éviter les re-renders)
  const [filteredUsersData, setFilteredUsersData] = useState([]);
  const [filteredUsersTotal, setFilteredUsersTotal] = useState(0);
  const [filteredBoutiquesData, setFilteredBoutiquesData] = useState([]);
  const [filteredBoutiquesTotal, setFilteredBoutiquesTotal] = useState(0);
  const [filteredProductsData, setFilteredProductsData] = useState([]);
  const [filteredProductsTotal, setFilteredProductsTotal] = useState(0);
  const [filteredAdsData, setFilteredAdsData] = useState([]);
  const [filteredAdsTotal, setFilteredAdsTotal] = useState(0);
  const [filteredSubscriptionPlansData, setFilteredSubscriptionPlansData] = useState([]);
  const [filteredSubscriptionPlansTotal, setFilteredSubscriptionPlansTotal] = useState(0);
  const [filteredSubscriptionsData, setFilteredSubscriptionsData] = useState([]);
  const [filteredSubscriptionsTotal, setFilteredSubscriptionsTotal] = useState(0);
  const [filteredServicesData, setFilteredServicesData] = useState([]);
  const [filteredServicesTotal, setFilteredServicesTotal] = useState(0);



  // États pour les modales
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [boutiqueModalOpen, setBoutiqueModalOpen] = useState(false);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [adModalOpen, setAdModalOpen] = useState(false);
  const [platformSettingsModalOpen, setPlatformSettingsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedBoutique, setSelectedBoutique] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedAd, setSelectedAd] = useState(null);
  const [subscriptionPlanModalOpen, setSubscriptionPlanModalOpen] = useState(false);
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);
  const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState(null);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [categorieModalOpen, setCategoryModalOpen] = useState(false);
  const [serviceModalOpen, setServiceModalOpen] = useState(false);
  const [categorieServiceModalOpen, setCategorieServiceModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedCategorieService, setSelectedCategorieService] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showCategorieServicesList, setShowCategorieServicesList] = useState(false);
  const [togglingCategories, setTogglingCategories] = useState(new Set());
  const [localCategoryStatuses, setLocalCategoryStatuses] = useState(new Map());


    // États pour le modal de confirmation
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationData, setConfirmationData] = useState({
    title: '',
    message: '',
    onConfirm: null,
    loading: false,
    confirmText: 'Confirmer',
    severity: 'warning'
  });


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Fonction pour ouvrir le modal de confirmation
  const openConfirmationModal = (title, message, onConfirm, confirmText = 'Confirmer', severity = 'warning') => {
    setConfirmationData({
      title,
      message,
      onConfirm,
      loading: false,
      confirmText,
      severity
    });
    setConfirmationModalOpen(true);
  };

  // Fonction pour fermer le modal de confirmation
  const closeConfirmationModal = () => {
    setConfirmationModalOpen(false);
    setConfirmationData({
      title: '',
      message: '',
      onConfirm: null,
      loading: false,
      confirmText: 'Confirmer',
      severity: 'warning'
    });
  };

  // Fonction pour confirmer l'action
  const handleConfirmAction = async () => {
    if (confirmationData.onConfirm) {
      setConfirmationData(prev => ({ ...prev, loading: true }));
      try {
        await confirmationData.onConfirm();
        closeConfirmationModal();
      } catch (error) {
        setConfirmationData(prev => ({ ...prev, loading: false }));
        // L'erreur sera gérée par la fonction appelante
      }
    }
  };

  // Fonctions pour gérer les notifications
  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
  };

  const clearNotification = () => {
    setNotification({ message: '', type: 'success' });
  };

  // Fonctions pour la gestion des approbations
  const handleToggleApproval = async (type, enabled) => {
    try {
      setLoading(true);
      // Mettre à jour l'état local d'abord
      const updatedSettings = { ...approvalSettings, [type]: enabled };
      // console.log('Mise à jour des paramètres:', updatedSettings);
      setApprovalSettings(updatedSettings);
      
      // Envoyer tous les paramètres d'approbation
      await adminService.updateApprovalSettings(updatedSettings);
      
      showNotification(
        `Approbation ${enabled ? 'activée' : 'désactivée'} pour ${type}`,
        'success'
      );
    } catch (error) {
      // En cas d'erreur, restaurer l'état précédent
      setApprovalSettings(prev => ({ ...prev, [type]: !enabled }));
      showNotification('Erreur lors de la mise à jour', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDisableAllApprovals = async () => {
    try {
      setLoading(true);
      await adminService.updateApprovalSettings({
        products: false,
        boutiques: false,
        reviews: false,
        users: false
      });
      setApprovalSettings({
        products: false,
        boutiques: false,
        reviews: false,
        users: false
      });
      showNotification('Toutes les approbations ont été désactivées', 'success');
    } catch (error) {
      showNotification('Erreur lors de la désactivation', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleResetToDefault = async () => {
    try {
      setLoading(true);
      await adminService.updateApprovalSettings({
        products: true,
        boutiques: true,
        reviews: true,
        users: true
      });
      setApprovalSettings({
        products: true,
        boutiques: true,
        reviews: true,
        users: true
      });
      showNotification('Paramètres remis par défaut', 'success');
    } catch (error) {
      showNotification('Erreur lors de la réinitialisation', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Fonctions de gestion de pagination
  const handleUserPageChange = (event, newPage) => {
    setUserPage(newPage);
  };

  const handleUserRowsPerPageChange = (event) => {
    setUserRowsPerPage(parseInt(event.target.value, 10));
    setUserPage(0);
  };

  const handleBoutiquePageChange = (event, newPage) => {
    setBoutiquePage(newPage);
  };

  const handleBoutiqueRowsPerPageChange = (event) => {
    setBoutiqueRowsPerPage(parseInt(event.target.value, 10));
    setBoutiquePage(0);
  };

  const handleProductPageChange = (event, newPage) => {
    setProductPage(newPage);
  };

  const handleProductRowsPerPageChange = (event) => {
    setProductRowsPerPage(parseInt(event.target.value, 10));
    setProductPage(0);
  };

  const handleAdPageChange = (event, newPage) => {
    setAdPage(newPage);
  };

  const handleAdRowsPerPageChange = (event) => {
    setAdRowsPerPage(parseInt(event.target.value, 10));
    setAdPage(0);
  };

  // Fonctions de gestion de recherche avec bouton
  const handleUserSearch = () => {
    setUserSearchTerm(userSearchInput);
    setUserPage(0); // Réinitialiser la page
  };

  const handleUserSearchClear = () => {
    setUserSearchInput('');
    setUserSearchTerm('');
    setUserPage(0);
  };

  const handleBoutiqueSearch = () => {
    setBoutiqueSearchTerm(boutiqueSearchInput);
    setBoutiquePage(0); // Réinitialiser la page
  };

  const handleBoutiqueSearchClear = () => {
    setBoutiqueSearchInput('');
    setBoutiqueSearchTerm('');
    setBoutiquePage(0);
  };

  const handleProductSearch = () => {
    setProductSearchTerm(productSearchInput);
    setProductPage(0); // Réinitialiser la page
  };

  const handleProductSearchClear = () => {
    setProductSearchInput('');
    setProductSearchTerm('');
    setProductPage(0);
  };

  const handleServiceSearch = () => {
    setServiceSearchTerm(serviceSearchInput);
    setServicePage(0); // Réinitialiser la page
  };

  const handleServiceSearchClear = () => {
    setServiceSearchInput('');
    setServiceSearchTerm('');
    setServicePage(0);
  };

  const handleSubscriptionSearch = () => {
    setSubscriptionSearchTerm(subscriptionSearchInput);
    setSubscriptionPage(0); // Réinitialiser la page
  };

  const handleSubscriptionSearchClear = () => {
    setSubscriptionSearchInput('');
    setSubscriptionSearchTerm('');
    setSubscriptionPage(0);
  };

  const handleAdSearch = () => {
    setAdSearchTerm(adSearchInput);
    setAdPage(0); // Réinitialiser la page
  };

  const handleAdSearchClear = () => {
    setAdSearchInput('');
    setAdSearchTerm('');
    setAdPage(0);
  };

  const handleReviewSearch = () => {
    setReviewSearchTerm(reviewSearchInput);
    setReviewPage(0); // Réinitialiser la page
  };

  const handleReviewSearchClear = () => {
    setReviewSearchInput('');
    setReviewSearchTerm('');
    setReviewPage(0);
  };

  const handleSubscriptionPlanSearch = () => {
    setSubscriptionPlanSearchTerm(subscriptionPlanSearchInput);
    setSubscriptionPlanPage(0); // Réinitialiser la page
  };

  const handleSubscriptionPlanSearchClear = () => {
    setSubscriptionPlanSearchInput('');
    setSubscriptionPlanSearchTerm('');
    setSubscriptionPlanPage(0);
  };

  // Handlers pour la pagination des formules d'abonnement
  const handleSubscriptionPlanPageChange = (event, newPage) => {
    setSubscriptionPlanPage(newPage);
  };

  const handleSubscriptionPlanRowsPerPageChange = (event) => {
    setSubscriptionPlanRowsPerPage(parseInt(event.target.value, 10));
    setSubscriptionPlanPage(0);
  };

  // Handlers pour la pagination des abonnements
  const handleSubscriptionPageChange = (event, newPage) => {
    setSubscriptionPage(newPage);
  };

  const handleSubscriptionRowsPerPageChange = (event) => {
    setSubscriptionRowsPerPage(parseInt(event.target.value, 10));
    setSubscriptionPage(0);
  };


  // Fonction pour recharger intelligemment selon l'onglet actif
  const reloadCurrentTab = () => {
    if (activeTab === 0) {
      loadUsers();
    } else if (activeTab === 1) {
      loadBoutiques();
    } else if (activeTab === 2) {
      loadProducts();
    } else if (activeTab === 3) {
      loadAds();
    } else if (activeTab === 4) {
     loadCategories();
    } else if (activeTab === 5) {
      loadServices();
      loadCategorieServices();
    } else if (activeTab === 6) {
      loadSubscriptionPlans();
    } else if (activeTab === 7) {  
      loadSubscriptions();
    } else if (activeTab === 8) {
      loadReviews();
    }
  };

  // useEffect pour mettre à jour les utilisateurs filtrés
  useEffect(() => {
    let filtered = users;
    
    // Recherche textuelle
    if (userSearchTerm) {
      const searchLower = userSearchTerm.toLowerCase();
      filtered = filtered.filter(user =>
        user.name?.toLowerCase().includes(searchLower) ||
        (user.email && user.email.toLowerCase().includes(searchLower)) ||
        (user.phone && user.phone.includes(searchLower)) ||
        user.role?.toLowerCase().includes(searchLower)
      );
    }
    
    // Filtre par rôle
    if (userRoleFilter && userRoleFilter !== '') {
      filtered = filtered.filter(user => user.role === userRoleFilter);
    }
    
    // Filtre par isBlocked
    if (userIsBlockedFilter !== '') {
      const isBlocked = userIsBlockedFilter === 'true';
      filtered = filtered.filter(user => user.isBlocked === isBlocked);
    }
    
    // Filtre par isApproved
    if (userIsApprovedFilter !== '') {
      const isApproved = userIsApprovedFilter === 'true';
      filtered = filtered.filter(user => user.isApproved === isApproved);
    }
    
    // Filtre par isEmailVerified
    if (userIsEmailVerifiedFilter !== '') {
      const isEmailVerified = userIsEmailVerifiedFilter === 'true';
      filtered = filtered.filter(user => user.isEmailVerified === isEmailVerified);
    }
    
    // Tri par date de création
    filtered = [...filtered].sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return userSortOrder === 'newest' ? dateB - dateA : dateA - dateB;
    });

    // Appliquer la pagination
    const startIndex = userPage * userRowsPerPage;
    const endIndex = startIndex + userRowsPerPage;

    setFilteredUsersData(filtered.slice(startIndex, endIndex));
    setFilteredUsersTotal(filtered.length);
  }, [users, userSearchTerm, userRoleFilter, userIsBlockedFilter, userIsApprovedFilter, userIsEmailVerifiedFilter, userSortOrder, userPage, userRowsPerPage]);

  // Calculer le nombre d'utilisateurs non approuvés
  const pendingUsersCount = useMemo(() => {
    return users.filter(user => user.isApproved === false).length;
  }, [users]);

  // useEffect pour mettre à jour les boutiques filtrées
  useEffect(() => {
    let filtered = boutiques;
    if (boutiqueSearchTerm) {
      const searchLower = boutiqueSearchTerm.toLowerCase();
      filtered = boutiques.filter(boutique => {
        const nameMatch = boutique.name?.toLowerCase().includes(searchLower);
        const descriptionMatch = boutique.description?.toLowerCase().includes(searchLower);
        const addressMatch = boutique.address?.toLowerCase().includes(searchLower);
        const quartierMatch = boutique.quartier?.toLowerCase().includes(searchLower);
        const userMatch = boutique.user?.name?.toLowerCase().includes(searchLower);
        const userEmailMatch = boutique.user?.email?.toLowerCase().includes(searchLower);
        const userPhoneMatch = boutique.user?.phone?.includes(searchLower);
        const whatsappMatch = boutique.whatsapp?.includes(searchLower);
        const phoneMatch = boutique.phone?.includes(searchLower);
        
        return nameMatch || descriptionMatch || addressMatch || quartierMatch || 
               userMatch || userEmailMatch || userPhoneMatch || whatsappMatch || phoneMatch;
      });
    }

    // Appliquer la pagination
    const startIndex = boutiquePage * boutiqueRowsPerPage;
    const endIndex = startIndex + boutiqueRowsPerPage;

    setFilteredBoutiquesData(filtered.slice(startIndex, endIndex));
    setFilteredBoutiquesTotal(filtered.length);
  }, [boutiques, boutiqueSearchTerm, boutiquePage, boutiqueRowsPerPage]);

  // useEffect pour mettre à jour les produits filtrés
  useEffect(() => {
    let filtered = products;
    
    // Recherche textuelle
    if (productSearchTerm) {
      const searchLower = productSearchTerm.toLowerCase();
      filtered = filtered.filter(product => {
        const nameMatch = product.name?.toLowerCase().includes(searchLower);
        const descriptionMatch = product.description?.toLowerCase().includes(searchLower);
        const categorieMatch = (product.categorie?.libelle || product.categorie?.code || product.categorie || '').toLowerCase().includes(searchLower);
        const priceMatch = product.price?.toString().includes(searchLower);
        const boutiqueMatch = product.boutique?.name?.toLowerCase().includes(searchLower);
        
        return nameMatch || descriptionMatch || categorieMatch || priceMatch || boutiqueMatch;
      });
    }
    
    // Filtre par isActive
    if (productIsActiveFilter !== '') {
      const isActive = productIsActiveFilter === 'true';
      filtered = filtered.filter(product => product.isActive === isActive);
    }
    
    // Filtre par isAvailable
    if (productIsAvailableFilter !== '') {
      const isAvailable = productIsAvailableFilter === 'true';
      filtered = filtered.filter(product => product.isAvailable === isAvailable);
    }

    // Appliquer la pagination
    const startIndex = productPage * productRowsPerPage;
    const endIndex = startIndex + productRowsPerPage;

    setFilteredProductsData(filtered.slice(startIndex, endIndex));
    setFilteredProductsTotal(filtered.length);
  }, [products, productSearchTerm, productIsActiveFilter, productIsAvailableFilter, productPage, productRowsPerPage]);

  // useEffect pour mettre à jour les annonces filtrées
  useEffect(() => {
    let filtered = ads;
    if (adSearchTerm) {
      const searchLower = adSearchTerm.toLowerCase();
      filtered = ads.filter(ad =>
        ad.title.toLowerCase().includes(searchLower) ||
        (ad.description && ad.description.toLowerCase().includes(searchLower)) ||
        (ad.targetUrl && ad.targetUrl.toLowerCase().includes(searchLower))
      );
    }

    // Appliquer la pagination
    const startIndex = adPage * adRowsPerPage;
    const endIndex = startIndex + adRowsPerPage;

    setFilteredAdsData(filtered.slice(startIndex, endIndex));
    setFilteredAdsTotal(filtered.length);
  }, [ads, adSearchTerm, adPage, adRowsPerPage]);

  // useEffect pour filtrer les services localement (comme pour les produits)
  useEffect(() => {
    let filtered = services;
    
    if (serviceSearchTerm) {
      const searchLower = serviceSearchTerm.toLowerCase();
      filtered = services.filter(service => {
        const nameMatch = service.name?.toLowerCase().includes(searchLower);
        const descriptionMatch = service.description?.toLowerCase().includes(searchLower);
        const userMatch = service.user?.name?.toLowerCase().includes(searchLower) || 
                         service.user?.email?.toLowerCase().includes(searchLower) ||
                         service.user?.phone?.toLowerCase().includes(searchLower);
        const boutiqueMatch = service.boutique?.name?.toLowerCase().includes(searchLower);
        const categoriesMatch = service.categories?.some(cat => 
          cat.categorieService?.libelle?.toLowerCase().includes(searchLower) || 
          cat.libelle?.toLowerCase().includes(searchLower)
        );
        
        return nameMatch || descriptionMatch || userMatch || boutiqueMatch || categoriesMatch;
      });
    }

    // Appliquer la pagination
    const startIndex = servicePage * serviceRowsPerPage;
    const endIndex = startIndex + serviceRowsPerPage;

    setFilteredServicesData(filtered.slice(startIndex, endIndex));
    setFilteredServicesTotal(filtered.length);
  }, [services, serviceSearchTerm, servicePage, serviceRowsPerPage]);

  // useEffect pour recharger les services quand les paramètres changent
  useEffect(() => {
    if (activeTab === 5) {
      loadServices();
      loadCategorieServices();
    }
  }, [servicePage, serviceRowsPerPage, activeTab]);

  // useEffect pour filtrer les formules d'abonnement localement (comme pour les produits)
  useEffect(() => {
    let filtered = subscriptionPlans;
    
    if (subscriptionPlanSearchTerm) {
      const searchLower = subscriptionPlanSearchTerm.toLowerCase();
      filtered = subscriptionPlans.filter(plan =>
        plan.code?.toLowerCase().includes(searchLower) ||
        plan.libelle?.toLowerCase().includes(searchLower) ||
        (plan.description && plan.description.toLowerCase().includes(searchLower)) ||
        plan.prix?.toString().includes(searchLower)
      );
    }

    // Appliquer la pagination
    const startIndex = subscriptionPlanPage * subscriptionPlanRowsPerPage;
    const endIndex = startIndex + subscriptionPlanRowsPerPage;

    setFilteredSubscriptionPlansData(filtered.slice(startIndex, endIndex));
    setFilteredSubscriptionPlansTotal(filtered.length);
  }, [subscriptionPlans, subscriptionPlanSearchTerm, subscriptionPlanPage, subscriptionPlanRowsPerPage]);

  // useEffect pour recharger les formules d'abonnement quand les paramètres changent (sans recherche)
  useEffect(() => {
    if (activeTab === 6 && !subscriptionPlanSearchTerm) {
      loadSubscriptionPlans();
    }
  }, [subscriptionPlanPage, subscriptionPlanRowsPerPage, activeTab]);

  // useEffect pour filtrer les abonnements localement (comme pour les produits)
  useEffect(() => {
    let filtered = subscriptions;
    
    if (subscriptionSearchTerm) {
      const searchLower = subscriptionSearchTerm.toLowerCase();
      filtered = subscriptions.filter(subscription => {
        const userNameMatch = subscription.user?.name?.toLowerCase().includes(searchLower);
        const userEmailMatch = subscription.user?.email?.toLowerCase().includes(searchLower);
        const userPhoneMatch = subscription.user?.phone?.toLowerCase().includes(searchLower);
        const formuleLibelleMatch = subscription.formule?.libelle?.toLowerCase().includes(searchLower);
        const formuleCodeMatch = subscription.formule?.code?.toLowerCase().includes(searchLower);
        const statutMatch = subscription.statut?.toLowerCase().includes(searchLower) || 
                          (subscription.statut === 'actif' && (searchLower.includes('actif') || searchLower.includes('active'))) ||
                          (subscription.statut === 'inactif' && (searchLower.includes('inactif') || searchLower.includes('inactive'))) ||
                          (subscription.statut === 'expiré' && (searchLower.includes('expiré') || searchLower.includes('expire') || searchLower.includes('expired')));
        const prixMatch = subscription.formule?.prix?.toString().includes(searchLower);
        
        return userNameMatch || userEmailMatch || userPhoneMatch || 
               formuleLibelleMatch || formuleCodeMatch || statutMatch || prixMatch;
      });
    }

    // Appliquer la pagination
    const startIndex = subscriptionPage * subscriptionRowsPerPage;
    const endIndex = startIndex + subscriptionRowsPerPage;

    setFilteredSubscriptionsData(filtered.slice(startIndex, endIndex));
    setFilteredSubscriptionsTotal(filtered.length);
  }, [subscriptions, subscriptionSearchTerm, subscriptionPage, subscriptionRowsPerPage]);

  // useEffect pour recharger les abonnements quand les paramètres changent (sans recherche)
  useEffect(() => {
    if (activeTab === 7 && !subscriptionSearchTerm) {
      loadSubscriptions();
    }
  }, [subscriptionPage, subscriptionRowsPerPage, activeTab]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      // Charger toutes les utilisateurs pour le filtrage côté client
      const data = await adminService.getUsers({ limit: 10000 });
      setUsers(data.users || []);
    } catch (err) {
      showNotification('Erreur lors du chargement des utilisateurs', 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadPendingApprovals = useCallback(async () => {
    try {
      const data = await adminService.getPendingApprovals();
      setPendingApprovals(data.count || 0);
      // Récupérer le nombre d'abonnements en attente
      if (data.details && data.details.subscriptions !== undefined) {
        setPendingSubscriptionsCount(data.details.subscriptions || 0);
      }
    } catch (error) {
      console.error('Error loading pending approvals:', error);
    }
  }, []);


  const loadBoutiques = async () => {
    try {
      setLoading(true);
      // Charger toutes les boutiques pour le filtrage côté client
      const data = await adminService.getBoutiques({ limit: 10000 });
      setBoutiques(data.boutiques || []);
      // Mettre à jour le compteur de boutiques en attente
      loadPendingProductsAndBoutiquesCount();
    } catch (err) {
      showNotification('Erreur lors du chargement des boutiques', 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadProducts = async () => {
    try {
      setLoading(true);
      // Charger tous les produits pour le filtrage côté client
      const data = await adminService.getProducts({ limit: 10000 });
      setProducts(data.products || []);
      // Mettre à jour le compteur de produits en attente
      loadPendingProductsAndBoutiquesCount();
    } catch (err) {
      showNotification('Erreur lors du chargement des produits', 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadAds = async () => {
    try {
      setLoading(true);
      const data = await adminService.getAds();
      setAds(data.ads);
    } catch (err) {
      showNotification('Erreur lors du chargement des annonces', 'error');
    } finally {
      setLoading(false);
    }
  };
  const loadSubscriptionPlans = async () => {
    try {
      setLoading(true);
      const params = {
        page: 1,
        limit: 10000 // Charger toutes les formules pour le filtrage local
      };
      const data = await subscriptionService.getSubscriptionPlans(params);
      // console.log('Subscription plans response:', data);
      setSubscriptionPlans(data.data || []);
      setSubscriptionPlanTotal(data.count || 0);
    } catch (err) {
      showNotification('Erreur lors du chargement des formules d\'abonnement', 'error');
      setSubscriptionPlans([]); // S'assurer que subscriptionPlans est toujours un tableau
    } finally {
      setLoading(false);
    }
  };

  const loadSubscriptions = async () => {
    try {
      setLoading(true);
      const params = {
        page: 1,
        limit: 10000 // Charger tous les abonnements pour le filtrage local
      };
      const data = await subscriptionService.getSubscriptions(params);
      // console.log('Subscriptions response:', data);
      setSubscriptions(data.data || []);
      setSubscriptionTotal(data.count || 0);
    } catch (err) {
      console.error('Error loading subscriptions:', err);
      showNotification('Erreur lors du chargement des abonnements', 'error');
      setSubscriptions([]); // S'assurer que subscriptions est toujours un tableau
    } finally {
      setLoading(false);
    }
  };

  const loadServices = async () => {
    try {
      setLoading(true);
      const response = await adminService.getServices({
        page: servicePage + 1,
        limit: serviceRowsPerPage
      });
      if (response.success) {
        setServices(response.data || []);
        setServiceTotal(response.pagination?.total || 0);
        setFilteredServicesData(response.data || []);
        setFilteredServicesTotal(response.pagination?.total || 0);
      }
    } catch (error) {
      console.error('Error loading services:', error);
      setNotification({ message: 'Erreur lors du chargement des services', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const loadCategorieServices = async () => {
    try {
      setLoading(true);
      const response = await adminService.getCategorieServices();
      if (response.success) {
        setCategorieServices(response.data || []);
      }
    } catch (error) {
      console.error('Error loading categorie services:', error);
      setNotification({ message: 'Erreur lors du chargement des catégories de services', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour charger uniquement le compteur de reviews en attente
  const loadPendingReviewsCount = async () => {
    try {
      const params = { page: 1, limit: 1 };
      const response = await adminService.getReviews(params);
      if (response.success && response.pendingCount !== undefined) {
        setPendingReviewsCount(response.pendingCount);
      }
    } catch (error) {
      console.error('Erreur lors du chargement du compteur de reviews en attente:', error);
      // Ne pas afficher de notification pour cette erreur silencieuse
    }
  };

  // Fonction pour charger les compteurs de produits et boutiques en attente
  const loadPendingProductsAndBoutiquesCount = async () => {
    try {
      const data = await adminService.getPendingApprovals();
      if (data && data.details) {
        setPendingProductsCount(data.details.products || 0);
        setPendingBoutiquesCount(data.details.boutiques || 0);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des compteurs de produits et boutiques en attente:', error);
      // Ne pas afficher de notification pour cette erreur silencieuse
    }
  };

  const loadReviews = async () => {
    try {
      setLoading(true);
      const params = {
        page: reviewPage + 1,
        limit: reviewRowsPerPage,
        ...(reviewSearchTerm && { search: reviewSearchTerm }),
        ...(reviewIsActiveFilter !== '' && { isActive: reviewIsActiveFilter }),
        ...(reviewTypeFilter && { reviewType: reviewTypeFilter })
      };
      const response = await adminService.getReviews(params);
      if (response.success) {
        setReviews(response.data || []);
        setReviewTotal(response.pagination?.total || 0);
        // Mettre à jour le nombre de commentaires en attente
        if (response.pendingCount !== undefined) {
          setPendingReviewsCount(response.pendingCount);
        }
      }
    } catch (error) {
      console.error('Erreur lors du chargement des avis:', error);
      showNotification('Erreur lors du chargement des avis', 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async () => {
    try {
      setLoading(true);
      // console.log('Loading categories...');
      const data = await categorieService.getAllCategories();
      // console.log('Categories data received:', data);
      // console.log('First category structure:', data?.[0]);
      setCategories(data || []);
      // Nettoyer l'état local des statuts seulement si demandé
      // if (clearLocalStatuses) {
      //   setLocalCategoryStatuses(new Map());
      // }
    } catch (err) {
      console.error('Error loading categories:', err);
      showNotification('Erreur lors du chargement des catégories', 'error');
      setCategories([]); // S'assurer que categories est toujours un tableau
    } finally {
      setLoading(false);
    }
  };


  const toggleUserStatus = (userId, isBlocked, userName) => {
    if (user?.role !== 'ADMIN') {
      showNotification('Accès refusé. Seuls les administrateurs peuvent modifier les statuts.', 'error');
      return;
    }

    const action = async () => {
      try {
        await adminService.blockUser(userId, isBlocked);
        showNotification(`Utilisateur ${isBlocked ? 'bloqué' : 'débloqué'} avec succès`);
        // Recharger seulement si on est sur l'onglet utilisateurs
        if (activeTab === 0) {
          loadUsers();
        }
      } catch (err) {
        console.error('Error toggling user status:', err);
        showNotification(`Erreur lors de la modification du statut: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      isBlocked ? 'Bloquer l\'utilisateur' : 'Débloquer l\'utilisateur',
      `Êtes-vous sûr de vouloir ${isBlocked ? 'bloquer' : 'débloquer'} l'utilisateur "${userName}" ?`,
      action,
      isBlocked ? 'Bloquer' : 'Débloquer',
      isBlocked ? 'error' : 'success'
    );
  };

  const toggleUserApproval = (userId, isApproved, userName, userEmail) => {
    if (user?.role !== 'ADMIN') {
      showNotification('Accès refusé. Seuls les administrateurs peuvent approuver les comptes.', 'error');
      return;
    }

    const action = async () => {
      try {
        await adminService.approveUser(userId, isApproved);
        showNotification(`Utilisateur ${isApproved ? 'approuvé' : 'refusé'} avec succès`);
        
        // Recharger les données
        if (activeTab === 0) {
          loadUsers();
        }
        loadPendingApprovals();
      } catch (err) {
        console.error('Error toggling user approval:', err);
        showNotification(`Erreur lors de l'approbation: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    const emailInfo = userEmail 
      ? ` Un email de notification sera envoyé à ${userEmail}.`
      : ' Aucun email ne sera envoyé car l\'utilisateur n\'a pas d\'adresse email.';

    openConfirmationModal(
      isApproved ? 'Approuver l\'utilisateur' : 'Refuser l\'utilisateur',
      `Êtes-vous sûr de vouloir ${isApproved ? 'approuver' : 'refuser'} l'utilisateur "${userName}" ?${emailInfo}`,
      action,
      isApproved ? 'Approuver' : 'Refuser',
      isApproved ? 'success' : 'error'
    );
  };

  const toggleBoutiqueStatus = (boutiqueId, isActive, boutiqueName, userEmail) => {
    const action = async () => {
      try {
        await adminService.updateBoutiqueStatus(boutiqueId, isActive);
        showNotification(`Boutique ${isActive ? 'activée' : 'désactivée'} avec succès`);
        // Recharger seulement si on est sur l'onglet boutiques
        if (activeTab === 1) {
          loadBoutiques();
        }
        // Mettre à jour le compteur de boutiques en attente
        loadPendingProductsAndBoutiquesCount();
      } catch (err) {
        console.error('Error toggling boutique status:', err);
        showNotification(`Erreur lors de la modification du statut de la boutique: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    const emailInfo = userEmail 
      ? ` Un email de notification sera envoyé à ${userEmail}.`
      : ' Aucun email ne sera envoyé car le propriétaire n\'a pas d\'adresse email.';

    openConfirmationModal(
      isActive ? 'Activer la boutique' : 'Désactiver la boutique',
      `Êtes-vous sûr de vouloir ${isActive ? 'activer' : 'désactiver'} la boutique "${boutiqueName}" ?${emailInfo}`,
      action,
      isActive ? 'Activer' : 'Désactiver',
      isActive ? 'success' : 'warning'
    );
  };

  const toggleProductStatus = (productId, isActive, productName, userEmail) => {
    const action = async () => {
      try {
        await adminService.updateProductStatus(productId, isActive);
        reloadCurrentTab();
        showNotification(`Produit ${isActive ? 'activé' : 'désactivé'} avec succès`, 'success');
        // Mettre à jour le compteur de produits en attente
        loadPendingProductsAndBoutiquesCount();
      } catch (err) {
        console.error('Error toggling product status:', err);
        showNotification(`Erreur lors de la modification du statut: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    const emailInfo = userEmail 
      ? ` Un email de notification sera envoyé à ${userEmail}.`
      : ' Aucun email ne sera envoyé car le propriétaire n\'a pas d\'adresse email.';

    openConfirmationModal(
      isActive ? 'Activer le produit' : 'Désactiver le produit',
      `Êtes-vous sûr de vouloir ${isActive ? 'activer' : 'désactiver'} le produit "${productName}" ?${emailInfo}`,
      action,
      isActive ? 'Activer' : 'Désactiver',
      isActive ? 'success' : 'warning'
    );
  };

  const toggleProductAvailability = (productId, isAvailable, productName) => {
    const action = async () => {
      try {
        await adminService.updateProductAvailability(productId, isAvailable);
        reloadCurrentTab();
        showNotification(`Produit ${isAvailable ? 'marqué comme disponible' : 'marqué comme en rupture'} avec succès`, 'success');
      } catch (err) {
        console.error('Error toggling product availability:', err);
        showNotification(`Erreur lors de la modification de la disponibilité: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      isAvailable ? 'Marquer comme disponible' : 'Marquer comme en rupture',
      `Êtes-vous sûr de vouloir ${isAvailable ? 'marquer le produit comme disponible' : 'marquer le produit comme en rupture'} pour "${productName}" ?`,
      action,
      isAvailable ? 'Marquer disponible' : 'Marquer en rupture',
      isAvailable ? 'success' : 'warning'
    );
  };

  const toggleProductVip = async (productId, isVip, productName) => {
    try {
      await adminService.updateProductVip(productId, isVip);
      reloadCurrentTab();
      showNotification(`Produit ${isVip ? 'marqué comme VIP' : 'retiré du statut VIP'} avec succès`, 'success');
    } catch (err) {
      console.error('Error toggling product VIP status:', err);
      showNotification(`Erreur lors de la modification du statut VIP: ${err.response?.data?.message || err.message}`, 'error');
    }
  };

  const deleteAd = (adId, adTitle) => {
    const action = async () => {
      try {
        await adminService.deleteAd(adId);
        showNotification('Annonce supprimée avec succès');
        // Recharger seulement si on est sur l'onglet annonces
        if (activeTab === 3) {
          loadAds();
        }
      } catch (err) {
        console.error('Error deleting ad:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer l\'annonce',
      `Êtes-vous sûr de vouloir supprimer l'annonce "${adTitle}" ? Cette action est irréversible.`,
      action,
      'Supprimer',
      'error'
    );
  };

  const toggleAdStatus = (adId, isActive, adTitle) => {
    const action = async () => {
      try {
        await adminService.toggleAdStatus(adId, isActive);
        showNotification(`Annonce ${isActive ? 'activée' : 'désactivée'} avec succès`);
        // Recharger seulement si on est sur l'onglet annonces
        if (activeTab === 3) {
          loadAds();
        }
      } catch (err) {
        console.error('Error toggling ad status:', err);
        showNotification(`Erreur lors de la modification du statut: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      isActive ? 'Activer l\'annonce' : 'Désactiver l\'annonce',
      `Êtes-vous sûr de vouloir ${isActive ? 'activer' : 'désactiver'} l'annonce "${adTitle}" ?`,
      action,
      isActive ? 'Activer' : 'Désactiver',
      isActive ? 'success' : 'warning'
    );
  };

  const deleteCategory = (categoryId, categoryName) => {
    const action = async () => {
      try {
        await categorieService.deleteCategory(categoryId);
        showNotification('Catégorie supprimée avec succès');
        // Recharger seulement si on est sur l'onglet catégories
        if (activeTab === 4) {
          loadCategories();
        }
      } catch (err) {
        console.error('Error deleting category:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer la catégorie',
      `Êtes-vous sûr de vouloir supprimer la catégorie "${categoryName}" ? Cette action est irréversible.`,
      action,
      'Supprimer',
      'error'
    );
  };

  // Supprimer un utilisateur et toutes ses données liées (cascade)
  const deleteUser = (userId, userName) => {
    const action = async () => {
      try {
        await adminService.deleteUser(userId);
        showNotification('Utilisateur et toutes ses données liées supprimés avec succès');
        // Recharger seulement si on est sur l'onglet utilisateurs
        if (activeTab === 0) {
          loadUsers();
        }
      } catch (err) {
        console.error('Error deleting user:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer l\'utilisateur',
      `Êtes-vous sûr de vouloir supprimer l'utilisateur "${userName}" ? Cette action supprimera également toutes ses boutiques, produits, services, avis et abonnements. Cette action est irréversible.`,
      action,
      'Supprimer',
      'error'
    );
  };

  // Supprimer une boutique et toutes ses données liées (cascade)
  const deleteBoutique = (boutiqueId, boutiqueName) => {
    const action = async () => {
      try {
        await adminService.deleteBoutique(boutiqueId);
        showNotification('Boutique et toutes ses données liées supprimées avec succès');
        // Recharger seulement si on est sur l'onglet boutiques
        if (activeTab === 1) {
          loadBoutiques();
        }
      } catch (err) {
        console.error('Error deleting boutique:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer la boutique',
      `Êtes-vous sûr de vouloir supprimer la boutique "${boutiqueName}" ? Cette action supprimera également tous ses produits, services et avis. Cette action est irréversible.`,
      action,
      'Supprimer',
      'error'
    );
  };

  // Supprimer un produit et toutes ses données liées (cascade)
  const deleteProduct = (productId, productName) => {
    const action = async () => {
      try {
        await adminService.deleteProduct(productId);
        showNotification('Produit et toutes ses données liées supprimés avec succès');
        // Recharger seulement si on est sur l'onglet produits
        if (activeTab === 2) {
          loadProducts();
        }
      } catch (err) {
        console.error('Error deleting product:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer le produit',
      `Êtes-vous sûr de vouloir supprimer le produit "${productName}" ? Cette action supprimera également tous ses avis. Cette action est irréversible.`,
      action,
      'Supprimer',
      'error'
    );
  };

  // Supprimer un abonnement
  const deleteSubscription = (subscriptionId, userName) => {
    const action = async () => {
      try {
        await subscriptionService.deleteSubscription(subscriptionId);
        showNotification('Abonnement supprimé avec succès');
        // Recharger seulement si on est sur l'onglet abonnements
        if (activeTab === 7) {
          loadSubscriptions();
        }
        loadPendingApprovals(); // Mettre à jour le badge des abonnements en attente
      } catch (err) {
        console.error('Error deleting subscription:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer l\'abonnement',
      `Êtes-vous sûr de vouloir supprimer définitivement l'abonnement de ${userName || 'cet utilisateur'} ? Cette action est irréversible.`,
      action,
      'Supprimer',
      'error'
    );
  };

  // Supprimer une formule d'abonnement
  const deleteSubscriptionPlan = (planId, planLibelle) => {
    const action = async () => {
      try {
        await subscriptionService.deleteSubscriptionPlan(planId);
        showNotification('Formule d\'abonnement supprimée avec succès');
        // Recharger seulement si on est sur l'onglet formules d'abonnement
        if (activeTab === 6) {
          loadSubscriptionPlans();
        }
      } catch (err) {
        console.error('Error deleting subscription plan:', err);
        showNotification(`Erreur lors de la suppression: ${err.response?.data?.message || err.message}`, 'error');
        throw err;
      }
    };

    openConfirmationModal(
      'Supprimer la formule d\'abonnement',
      `Êtes-vous sûr de vouloir supprimer la formule "${planLibelle}" ? Cette action est irréversible. Note: La formule FREE ne peut pas être supprimée et les formules avec des abonnements actifs ne peuvent pas être supprimées.`,
      action,
      'Supprimer',
      'error'
    );
  };

  useEffect(() => {
    // Charger les données seulement si on change d'onglet
    if (activeTab === 0) {
      loadUsers();
    } else if (activeTab === 1) {
      loadBoutiques();
    } else if (activeTab === 2) {
      loadProducts();
    } else if (activeTab === 3) {
      loadAds();
    } else if (activeTab === 4) {
      loadCategories();
    } else if (activeTab === 5) {
      loadServices();
      loadCategorieServices();
    } else if (activeTab === 6) {
      loadSubscriptionPlans();
    } else if(activeTab === 7) {
      loadSubscriptions();
    } else if(activeTab === 8) {
      loadReviews();
    }
    // Charger les approbations en attente à chaque changement d'onglet
    loadPendingApprovals();
  }, [activeTab]);

  // Recharger les avis quand les filtres ou la pagination changent
  useEffect(() => {
    if (activeTab === 8) {
      loadReviews();
    }
  }, [reviewPage, reviewRowsPerPage, reviewSearchTerm, reviewIsActiveFilter, reviewTypeFilter]);
  // === FONCTIONS POUR LES PARAMÈTRES SYSTÈME ===

  const handleLogoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Vérifier le type de fichier
    if (!file.type.startsWith('image/')) {
      showNotification('Veuillez sélectionner un fichier image', 'error');
      return;
    }

    // Vérifier la taille (max 50MB - sera compressé en WebP)
    if (file.size > 50 * 1024 * 1024) {
      showNotification('La taille du fichier ne doit pas dépasser 50MB', 'error');
      return;
    }

    try {
      // Test de l'endpoint avant l'upload
      const testResponse = await api.get('/admin/upload-test');
      // console.log('Test endpoint response:', testResponse.data);

      // Créer un FormData pour l'upload
      const formData = new FormData();
      formData.append('logo', file);
      
      // Upload du fichier
      const response = await api.post('/admin/upload-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      // console.log('Upload response status:', response.status);
      // console.log('Upload response data:', response.data);
      
      if (response.data && response.data.logoUrl) {
        await adminService.updateSystemSetting('site_logo', response.data.logoUrl);
        await loadSettings(true); // Recharger les paramètres
        showNotification('Logo uploadé avec succès', 'success');
      } else {
        throw new Error('Aucune URL de logo retournée');
      }
      
    } catch (error) {
      console.error('Erreur lors de l\'upload du logo:', error);
      showNotification(`Erreur lors de l'upload du logo: ${error.message}`, 'error');
    }
  };

  const handleIconUpload = async (event, iconType) => {
    const file = event.target.files[0];
    if (!file) return;

    // Vérifier le type de fichier
    if (!file.type.startsWith('image/')) {
      showNotification('Le fichier doit être une image', 'error');
      return;
    }

    // Vérifier la taille selon le type d'icône
    const maxSize = iconType === 'favicon' ? 1 * 1024 * 1024 : 50 * 1024 * 1024; // 1MB pour favicon, 50MB pour apple-touch-icon (sera compressé en WebP)
    if (file.size > maxSize) {
      showNotification(`La taille du fichier ne doit pas dépasser ${iconType === 'favicon' ? '1MB' : '50MB'}`, 'error');
      return;
    }

    try {
      // Créer un FormData pour l'upload
      const formData = new FormData();
      formData.append('logo', file);
      
      // Upload du fichier (utiliser la même route que le logo)
      const response = await api.post('/admin/upload-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (response.data && response.data.logoUrl) {
        const settingKey = iconType === 'favicon' ? 'site_favicon' : 'site_apple_touch_icon';
        await adminService.updateSystemSetting(settingKey, response.data.logoUrl);
        await loadSettings(true); // Recharger les paramètres
        showNotification(`${iconType === 'favicon' ? 'Favicon' : 'Apple Touch Icon'} uploadé avec succès`, 'success');
      } else {
        throw new Error('Aucune URL d\'icône retournée');
      }
      
    } catch (error) {
      console.error(`Erreur lors de l'upload de l'icône:`, error);
      showNotification(`Erreur lors de l'upload de l'icône: ${error.message}`, 'error');
    }
    
    // Réinitialiser l'input pour permettre de re-sélectionner le même fichier
    event.target.value = '';
  };

  const handleDeleteIcon = async (iconType) => {
    try {
      const settingKey = iconType === 'logo' ? 'site_logo' : iconType === 'favicon' ? 'site_favicon' : 'site_apple_touch_icon';
      const iconName = iconType === 'logo' ? 'Logo' : iconType === 'favicon' ? 'Favicon' : 'Apple Touch Icon';
      
      await adminService.updateSystemSetting(settingKey, '');
      await loadSettings(true); // Recharger les paramètres
      showNotification(`${iconName} supprimé avec succès`, 'success');
    } catch (error) {
      console.error(`Erreur lors de la suppression de l'icône:`, error);
      showNotification(`Erreur lors de la suppression de l'icône: ${error.message}`, 'error');
    }
  };

  // Charger les paramètres d'approbation au montage initial
  useEffect(() => {
    const loadApprovalSettings = async () => {
      try {
        const data = await adminService.getApprovalSettings();
        if (data && data.settings) {
          setApprovalSettings(data.settings);
        }
      } catch (error) {
        console.error('Error loading approval settings:', error);
      }
    };
    loadApprovalSettings();
    // Charger les compteurs en attente au montage
    loadPendingReviewsCount();
    loadPendingProductsAndBoutiquesCount();
    loadPendingApprovals();
  }, []); // Charger une seule fois au montage

  useEffect(() => {
    const loadData = async () => {
      // Charger les données seulement si on change d'onglet
      if (activeTab === 0) {
        try {
          setLoading(true);
          const data = await adminService.getUsers();
          setUsers(data.users);
        } catch (err) {
          showNotification('Erreur lors du chargement des utilisateurs', 'error');
        } finally {
          setLoading(false);
        }
      } else if (activeTab === 1) {
        try {
          setLoading(true);
          const data = await adminService.getBoutiques();
          setBoutiques(data.boutiques);
        } catch (err) {
          showNotification('Erreur lors du chargement des boutiques', 'error');
        } finally {
          setLoading(false);
        }
      } else if (activeTab === 2) {
        try {
          setLoading(true);
          const data = await adminService.getProducts();
          setProducts(data.products);
        } catch (err) {
          showNotification('Erreur lors du chargement des produits', 'error');
        } finally {
          setLoading(false);
        }
      }
      
      // Charger les approbations en attente à chaque changement d'onglet
      loadPendingApprovals();
      
      // Recharger les compteurs en attente à chaque changement d'onglet
      loadPendingReviewsCount();
      loadPendingProductsAndBoutiquesCount();
      
      // Recharger les paramètres d'approbation si on est sur l'onglet approbation
      if (activeTab === 3) {
        try {
          const data = await adminService.getApprovalSettings();
          if (data && data.settings) {
            setApprovalSettings(data.settings);
          }
        } catch (error) {
          console.error('Error loading approval settings:', error);
        }
      }
      
      // Charger les paramètres système si on est sur l'onglet paramètres
      if (activeTab === 9) {
        try {
          await loadSettings(true); // Utiliser le contexte global
        } catch (error) {
          console.error('Erreur lors du chargement des paramètres:', error);
          showNotification('Erreur lors du chargement des paramètres', 'error');
        }
      }
    };
    
    loadData();
  }, [activeTab, loadSettings]);

  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );

  // Vérifier si l'utilisateur est admin
  if (user?.role !== 'ADMIN') {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="error">
          Accès refusé. Seuls les administrateurs peuvent accéder à cette page.
        </Alert>
      </Container>
    );
  }

  // Calcul des statistiques
  const statistics = {
    totalUsers: users.length,
    totalBoutiques: boutiques.length,
    totalServices: services.length,
    totalAnnonces: ads.length,
    totalProducts: products.length
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <IconButton
          onClick={() => setShowStatistics(!showStatistics)}
          sx={{
            bgcolor: showStatistics ? 'primary.main' : 'action.hover',
            color: showStatistics ? 'white' : 'text.primary',
            '&:hover': {
              bgcolor: showStatistics ? 'primary.dark' : 'action.selected'
            }
          }}
        >
          {showStatistics ? <VisibilityOff /> : <Visibility />}
        </IconButton>
        <Typography variant="h4" gutterBottom sx={{ mb: 0 }}>
          Espace d'Administration
        </Typography>
      </Box>

      {/* Section Statistiques */}
      {showStatistics && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3,
            overflowX: 'auto',
            overflowY: 'hidden',
            pb: 2,
            mb: 4,
            '&::-webkit-scrollbar': {
              height: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          }}
        >
          <Card sx={{ 
            background: 'gray',
            color: 'white',
            minHeight: '120px',
            height: '120px',
            minWidth: { xs: 180, sm: 210 },
            width: { xs: 180, sm: 210 },
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <People sx={{ fontSize: { xs: 18, sm: 20 }, opacity: 0.8 }} />
              </Box>
              <Typography variant="h3" sx={{ fontWeight: 400, mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                {statistics.totalUsers}
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                Utilisateurs
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ 
            background: 'gray',
            color: 'white',
            minHeight: '120px',
            height: '120px',
            minWidth: { xs: 180, sm: 210 },
            width: { xs: 180, sm: 210 },
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Store sx={{ fontSize: { xs: 18, sm: 20 }, opacity: 0.8 }} />
              </Box>
              <Typography variant="h3" sx={{ fontWeight: 400, mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                {statistics.totalBoutiques}
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                Boutiques
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ 
            background: 'gray',
            color: 'white',
            minHeight: '120px',
            height: '120px',
            minWidth: { xs: 180, sm: 210 },
            width: { xs: 180, sm: 210 },
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Work sx={{ fontSize: { xs: 18, sm: 20 }, opacity: 0.8 }} />
              </Box>
              <Typography variant="h3" sx={{ fontWeight: 400, mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                {statistics.totalServices}
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                Services
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ 
            background: 'gray',
            color: 'white',
            minHeight: '120px',
            height: '120px',
            minWidth: { xs: 180, sm: 210 },
            width: { xs: 180, sm: 210 },
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Campaign sx={{ fontSize: { xs: 18, sm: 20 }, opacity: 0.8 }} />
              </Box>
              <Typography variant="h3" sx={{ fontWeight: 400, mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                {statistics.totalAnnonces}
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                Annonces
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ 
            background: 'gray',
            color: 'white',
            minHeight: '120px',
            height: '120px',
            minWidth: { xs: 180, sm: 210 },
            width: { xs: 180, sm: 210 },
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <ShoppingBag sx={{ fontSize: { xs: 18, sm: 20 }, opacity: 0.8 }} />
              </Box>
              <Typography variant="h3" sx={{ fontWeight: 400, mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                {statistics.totalProducts}
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                Produits
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}


      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 3, borderColor: 'divider', width: '100%' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              maxWidth: '100vw',
              '& .MuiTab-root': {
                minWidth: 'auto',
                px: 2,
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                textTransform: 'none', 
                fontWeight: 500 
              }
            }}
          >
            <Tab 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Utilisateurs
                  {pendingUsersCount > 0 && (
                    <Box
                      sx={{
                        backgroundColor: 'warning.main',
                        color: 'white',
                        borderRadius: '50%',
                        minWidth: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        px: 0.5
                      }}
                    >
                      {pendingUsersCount}
                    </Box>
                  )}
                </Box>
              } 
            />
            <Tab 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Boutiques
                  {pendingBoutiquesCount > 0 && (
                    <Box
                      sx={{
                        backgroundColor: 'warning.main',
                        color: 'white',
                        borderRadius: '50%',
                        minWidth: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        px: 0.5
                      }}
                    >
                      {pendingBoutiquesCount}
                    </Box>
                  )}
                </Box>
              } 
            />
            <Tab 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Produits
                  {pendingProductsCount > 0 && (
                    <Box
                      sx={{
                        backgroundColor: 'warning.main',
                        color: 'white',
                        borderRadius: '50%',
                        minWidth: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        px: 0.5
                      }}
                    >
                      {pendingProductsCount}
                    </Box>
                  )}
                </Box>
              } 
            />
            <Tab label="Les annonces" />
            <Tab label="Catégories" />
            <Tab label="Services" />
            <Tab label="Formules d'abonnement" />
            <Tab 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Abonnements
                  {pendingSubscriptionsCount > 0 && (
                    <Box
                      sx={{
                        backgroundColor: 'warning.main',
                        color: 'white',
                        borderRadius: '50%',
                        minWidth: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        px: 0.5
                      }}
                    >
                      {pendingSubscriptionsCount}
                    </Box>
                  )}
                </Box>
              } 
            />
            <Tab 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Avis
                  {pendingReviewsCount > 0 && (
                    <Box
                      sx={{
                        backgroundColor: 'warning.main',
                        color: 'white',
                        borderRadius: '50%',
                        minWidth: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        px: 0.5
                      }}
                    >
                      {pendingReviewsCount}
                    </Box>
                  )}
                </Box>
              } 
            />
            <Tab label="Approbation"/>
            <Tab label="Paramètres" />
            <Tab label="Logs de Sécurité" />

          </Tabs>
        </Box>

        {/* Onglet Utilisateurs */}
        <TabPanel value={activeTab} index={0}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">Gestion des Utilisateurs</Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setUserModalOpen(true)}
            >
              Ajouter un utilisateur
            </Button>
          </Box>

          {/* Zone de recherche et filtres pour les utilisateurs */}
          <Box sx={{ mb: 3 }}>
            {/* Zone de recherche textuelle */}
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleUserSearch();
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#f5f5f5',
                  borderRadius: 2,
                  px: 2,
                  py: 0.5,
                  width: 400,
                  '&:hover': {
                    backgroundColor: '#eeeeee'
                  },
                  '&:focus-within': {
                    backgroundColor: 'white',
                    boxShadow: '0 0 0 2px #1976d2'
                  }
                }}
              >
                <Search sx={{ color: 'text.secondary', mr: 1 }} />
                <InputBase
                  placeholder="Rechercher des utilisateurs..."
                  value={userSearchInput}
                  onChange={(e) => setUserSearchInput(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleUserSearch();
                    }
                  }}
                  sx={{ flexGrow: 1 }}
                  autoFocus={userSearchInput.length > 0}
                />
              </Box>
              
              {userSearchInput && (
                <Button
                  variant="contained"
                  startIcon={<Search />}
                  onClick={handleUserSearch}
                  sx={{ minWidth: 100 }}
                >
                  Rechercher
                </Button>
              )}
              
              {userSearchInput && (
                <Button
                  variant="outlined"
                  onClick={handleUserSearchClear}
                  sx={{ minWidth: 80 }}
                >
                  Effacer
                </Button>
              )}
              
              {userSearchTerm && (
                <Typography variant="caption" color="text.secondary">
                  {filteredUsersTotal} résultats
                </Typography>
              )}
            </Box>
            
            {/* Filtres par listes déroulantes */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 2,
                overflowX: 'auto',
                overflowY: 'hidden',
                pb: 1,
                pt:2,
                mt: 1,
                '&::-webkit-scrollbar': {
                  height: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
              }}
            >
              <FormControl size="small" sx={{ minWidth: 150, flexShrink: 0 }}>
                <InputLabel id="user-role-filter-label">Rôle</InputLabel>
                <Select
                  labelId="user-role-filter-label"
                  value={userRoleFilter}
                  label="Rôle"
                  onChange={(e) => {
                    setUserRoleFilter(e.target.value);
                    setUserPage(0);
                  }}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="ADMIN">Admin</MenuItem>
                  <MenuItem value="VENDOR">Vendeur</MenuItem>
                  <MenuItem value="USER">Utilisateur</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl size="small" sx={{ minWidth: 150, flexShrink: 0 }}>
                <InputLabel id="user-blocked-filter-label">Statut</InputLabel>
                <Select
                  labelId="user-blocked-filter-label"
                  value={userIsBlockedFilter}
                  label="Statut"
                  onChange={(e) => {
                    setUserIsBlockedFilter(e.target.value);
                    setUserPage(0);
                  }}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="false">Actif</MenuItem>
                  <MenuItem value="true">Bloqué</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl size="small" sx={{ minWidth: 150, flexShrink: 0 }}>
                <InputLabel id="user-approved-filter-label">Approuvé</InputLabel>
                <Select
                  labelId="user-approved-filter-label"
                  value={userIsApprovedFilter}
                  label="Approuvé"
                  onChange={(e) => {
                    setUserIsApprovedFilter(e.target.value);
                    setUserPage(0);
                  }}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="true">Oui</MenuItem>
                  <MenuItem value="false">Non</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl size="small" sx={{ minWidth: 150, flexShrink: 0 }}>
                <InputLabel id="user-email-verified-filter-label">Email vérifié</InputLabel>
                <Select
                  labelId="user-email-verified-filter-label"
                  value={userIsEmailVerifiedFilter}
                  label="Email vérifié"
                  onChange={(e) => {
                    setUserIsEmailVerifiedFilter(e.target.value);
                    setUserPage(0);
                  }}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="true">Oui</MenuItem>
                  <MenuItem value="false">Non</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl size="small" sx={{ minWidth: 180, flexShrink: 0 }}>
                <InputLabel id="user-sort-order-label">Ordre de création</InputLabel>
                <Select
                  labelId="user-sort-order-label"
                  value={userSortOrder}
                  label="Ordre de création"
                  onChange={(e) => {
                    setUserSortOrder(e.target.value);
                    setUserPage(0);
                  }}
                >
                  <MenuItem value="newest">Plus récents</MenuItem>
                  <MenuItem value="oldest">Plus anciens</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Utilisateur</TableCell>
                  <TableCell>Email/Téléphone</TableCell>
                  <TableCell>Rôle</TableCell>
                  <TableCell>Accepté?</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 0 ? (
                  // Skeleton pour le chargement
                  Array.from({ length: userRowsPerPage }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                          <Skeleton variant="text" width={150} height={20} />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={180} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
                          <Skeleton variant="circular" width={32} height={32} />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  filteredUsersData.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar src={user.profilePhoto} sx={{ mr: 2 }}>
                            {user.name?.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="subtitle2">{user.name}</Typography>

                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {user.email || user.phone}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={user.role}
                          color={user.role === 'ADMIN' ? 'error' : user.role === 'VENDOR' ? 'warning' : 'default'}
                          size="small"
                        />
                      </TableCell>

                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Chip
                            label={user.isApproved ? 'Oui' : 'Non'}
                            color={user.isApproved ? 'success' : 'error'}
                            size="small"
                          />
                          {!user.isApproved && (
                            <IconButton
                              size="small"
                              color="success"
                              onClick={() => toggleUserApproval(user.id, true, user.name, user.email)}
                              title="Approuver"
                            >
                              <PersonAdd fontSize="small" />
                            </IconButton>
                          )}
                          {user.isApproved && user.role !== 'ADMIN' && (
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => toggleUserApproval(user.id, false, user.name, user.email)}
                              title="Refuser"
                            >
                              <PersonRemove fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={user.isBlocked ? 'Bloqué' : 'Actif'}
                          color={user.isBlocked ? 'error' : 'success'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <IconButton onClick={() => {
                            setSelectedUser(user);
                            setUserModalOpen(true);
                          }}
                          title="Modifier l'utilisateur"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton onClick={() => toggleUserStatus(user.id, !user.isBlocked, user.name)}
                            title={user.isBlocked ? 'Débloquer l\'utilisateur' : 'Bloquer l\'utilisateur'}
                          >
                            {user.isBlocked ? <CheckCircle /> : <Block />}
                          </IconButton>
                          <IconButton 
                            onClick={() => deleteUser(user.id, user.name)}
                            color="error"
                            title="Supprimer l'utilisateur et toutes ses données"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination pour les utilisateurs */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredUsersTotal}
            rowsPerPage={userRowsPerPage}
            page={userPage}
            onPageChange={handleUserPageChange}
            onRowsPerPageChange={handleUserRowsPerPageChange}
            labelRowsPerPage="Lignes par page:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
          />
        </TabPanel>

        {/* Onglet Boutiques */}
        <TabPanel value={activeTab} index={1}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">Gestion des Boutiques</Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setBoutiqueModalOpen(true)}
            >
              Ajouter une boutique
            </Button>
          </Box>

          {/* Zone de recherche style navbar pour les boutiques */}
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleBoutiqueSearch();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                px: 2,
                py: 0.5,
                width: 400,
                '&:hover': {
                  backgroundColor: '#eeeeee'
                },
                '&:focus-within': {
                  backgroundColor: 'white',
                  boxShadow: '0 0 0 2px #1976d2'
                }
              }}
            >
              <Search sx={{ color: 'text.secondary', mr: 1 }} />
              <InputBase
                placeholder="Rechercher des boutiques..."
                value={boutiqueSearchInput}
                onChange={(e) => setBoutiqueSearchInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleBoutiqueSearch();
                  }
                }}
                sx={{ flexGrow: 1 }}
                autoFocus={boutiqueSearchInput.length > 0}
              />
            </Box>
            
            {boutiqueSearchInput && (
              <Button
                variant="contained"
                startIcon={<Search />}
                onClick={handleBoutiqueSearch}
                sx={{ minWidth: 100 }}
              >
                Rechercher
              </Button>
            )}
            
            {boutiqueSearchInput && (
              <Button
                variant="outlined"
                onClick={handleBoutiqueSearchClear}
                sx={{ minWidth: 80 }}
              >
                Effacer
              </Button>
            )}
            
            {boutiqueSearchTerm && (
              <Typography variant="caption" color="text.secondary">
                {filteredBoutiquesTotal} résultats
              </Typography>
            )}
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Boutique</TableCell>
                  <TableCell>Propriétaire</TableCell>
                  <TableCell>Adresse</TableCell>
                  <TableCell>Visites</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 1 ? (
                  // Skeleton pour le chargement
                  Array.from({ length: boutiqueRowsPerPage }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                          <Box>
                            <Skeleton variant="text" width={150} height={20} />
                            <Skeleton variant="text" width={200} height={16} sx={{ mt: 0.5 }} />
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={120} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={180} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={50} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  filteredBoutiquesData.map((boutique) => (
                    <TableRow key={boutique.id}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar src={boutique.logo} sx={{ mr: 2 }}>
                            {boutique.name?.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="subtitle2">{boutique.name}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {boutique.description}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>{boutique.user?.name}</TableCell>
                      <TableCell>{boutique.address}</TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {boutique.visitCount || 0}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={boutique.isActive ? 'Active' : 'Inactive'}
                          color={boutique.isActive ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <IconButton onClick={() => {
                            setSelectedBoutique(boutique);
                            setBoutiqueModalOpen(true);
                          }}
                          title="Modifier la boutique"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton onClick={() => toggleBoutiqueStatus(boutique.id, !boutique.isActive, boutique.name, boutique.user?.email)}
                            title={boutique.isActive ? 'Désactiver la boutique' : 'Activer la boutique'}
                          >
                            {boutique.isActive ? <Block /> : <CheckCircle />}
                          </IconButton>
                          <IconButton 
                            onClick={() => deleteBoutique(boutique.id, boutique.name)}
                            color="error"
                            title="Supprimer la boutique et toutes ses données"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination pour les boutiques */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredBoutiquesTotal}
            rowsPerPage={boutiqueRowsPerPage}
            page={boutiquePage}
            onPageChange={handleBoutiquePageChange}
            onRowsPerPageChange={handleBoutiqueRowsPerPageChange}
            labelRowsPerPage="Lignes par page:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
          />
        </TabPanel>

        {/* Onglet Produits */}
        <TabPanel value={activeTab} index={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">Gestion des Produits</Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setProductModalOpen(true)}
            >
              Ajouter un produit
            </Button>
          </Box>

          {/* Zone de recherche style navbar pour les produits */}
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleProductSearch();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                px: 2,
                py: 0.5,
                width: 400,
                '&:hover': {
                  backgroundColor: '#eeeeee'
                },
                '&:focus-within': {
                  backgroundColor: 'white',
                  boxShadow: '0 0 0 2px #1976d2'
                }
              }}
            >
              <Search sx={{ color: 'text.secondary', mr: 1 }} />
              <InputBase
                placeholder="Rechercher des produits..."
                value={productSearchInput}
                onChange={(e) => setProductSearchInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleProductSearch();
                  }
                }}
                sx={{ flexGrow: 1 }}
                autoFocus={productSearchInput.length > 0}
              />
            </Box>
            
            {productSearchInput && (
              <Button
                variant="contained"
                startIcon={<Search />}
                onClick={handleProductSearch}
                sx={{ minWidth: 100 }}
              >
                Rechercher
              </Button>
            )}
            
            {productSearchInput && (
              <Button
                variant="outlined"
                onClick={handleProductSearchClear}
                sx={{ minWidth: 80 }}
              >
                Effacer
              </Button>
            )}
            
            {productSearchTerm && (
              <Typography variant="caption" color="text.secondary">
                {filteredProductsTotal} résultats
              </Typography>
            )}
          </Box>
          
          {/* Filtres par listes déroulantes */}
          <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap', gap: 2 }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="product-active-filter-label">Statut</InputLabel>
              <Select
                labelId="product-active-filter-label"
                value={productIsActiveFilter}
                label="Statut"
                onChange={(e) => {
                  setProductIsActiveFilter(e.target.value);
                  setProductPage(0);
                }}
              >
                <MenuItem value="">Tous</MenuItem>
                <MenuItem value="true">Actif</MenuItem>
                <MenuItem value="false">Inactif</MenuItem>
              </Select>
            </FormControl>
            
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="product-available-filter-label">Disponibilité</InputLabel>
              <Select
                labelId="product-available-filter-label"
                value={productIsAvailableFilter}
                label="Disponibilité"
                onChange={(e) => {
                  setProductIsAvailableFilter(e.target.value);
                  setProductPage(0);
                }}
              >
                <MenuItem value="">Tous</MenuItem>
                <MenuItem value="true">Disponible</MenuItem>
                <MenuItem value="false">En rupture</MenuItem>
              </Select>
            </FormControl>
          </Stack>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Produit</TableCell>
                  <TableCell>Prix</TableCell>
                  <TableCell>Stock</TableCell>
                  <TableCell>Catégorie</TableCell>
                  <TableCell>Boutique</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Disponibilité</TableCell>
                  <TableCell>VIP</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 2 ? (
                  // Skeleton pour le chargement
                  Array.from({ length: productRowsPerPage }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                          <Box>
                            <Skeleton variant="text" width={150} height={20} />
                            <Skeleton variant="text" width={200} height={16} sx={{ mt: 0.5 }} />
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={80} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={50} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={100} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={120} height={20} />
                        <Skeleton variant="text" width={100} height={16} sx={{ mt: 0.5 }} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={90} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={50} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="rectangular" width={40} height={20} sx={{ borderRadius: 10 }} />
                          <Skeleton variant="circular" width={40} height={40} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  filteredProductsData.map((product) => (
                    <TableRow key={product.id}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar src={product.images?.[0]} sx={{ mr: 2 }}>
                            {product.name?.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="subtitle2">{product.name}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {product.description}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>{product.price} fcfa</TableCell>
                      <TableCell>{product.stockQuantity}</TableCell>
                      <TableCell>
                        {product.categorie?.libelle || product.categorie?.code || product.categorie || 'Aucune'}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {product.boutique?.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {product.boutique?.user?.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={product.isActive ? 'Actif' : 'Inactif'}
                          color={product.isActive ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={product.isAvailable ? 'Disponible' : 'En rupture'}
                          color={product.isAvailable ? 'success' : 'warning'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        {product.isVip ? (
                          <Chip
                            label="VIP"
                            color="warning"
                            size="small"
                            sx={{ fontWeight: 600 }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">-</Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <IconButton onClick={() => {
                            setSelectedProduct(product);
                            setProductModalOpen(true);
                          }}
                          title="Modifier le produit"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton onClick={() => toggleProductStatus(product.id, !product.isActive, product.name, product.boutique?.user?.email)}
                            title={product.isActive ? 'Désactiver le produit' : 'Activer le produit'}
                          >
                            {product.isActive ? <Block /> : <CheckCircle />}
                          </IconButton>
                          <IconButton 
                            onClick={() => toggleProductAvailability(product.id, !product.isAvailable, product.name)}
                            title={product.isAvailable ? 'Marquer comme en rupture' : 'Marquer comme disponible'}
                            color={product.isAvailable ? 'success' : 'warning'}
                          >
                            <Inventory />
                          </IconButton>
                          <Switch
                            checked={product.isVip || false}
                            onChange={(e) => toggleProductVip(product.id, e.target.checked, product.name)}
                            size="small"
                            color="warning"
                            title={product.isVip ? 'Retirer le produit du mode VIP' : 'Mettre le produit en mode VIP'}
                          />
                          <IconButton 
                            onClick={() => deleteProduct(product.id, product.name)}
                            color="error"
                            title="Supprimer le produit et toutes ses données"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination pour les produits */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredProductsTotal}
            rowsPerPage={productRowsPerPage}
            page={productPage}
            onPageChange={handleProductPageChange}
            onRowsPerPageChange={handleProductRowsPerPageChange}
            labelRowsPerPage="Lignes par page:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
          />
        </TabPanel>

        {/* Onglet Annonces */}
        <TabPanel value={activeTab} index={3}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">Gestion des Annonces</Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => {
                setSelectedAd(null);
                setAdModalOpen(true);
              }}
            >
              Créer une annonce
            </Button>
          </Box>

          {/* Barre de recherche pour les annonces */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleAdSearch();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                px: 2,
                py: 0.5,
                width: 400,
                '&:hover': {
                  backgroundColor: '#eeeeee'
                },
                '&:focus-within': {
                  backgroundColor: 'white',
                  boxShadow: '0 0 0 2px #1976d2'
                }
              }}
            >
              <Search sx={{ color: 'text.secondary', mr: 1 }} />
              <InputBase
                placeholder="Rechercher des annonces..."
                value={adSearchInput}
                onChange={(e) => setAdSearchInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleAdSearch();
                  }
                }}
                sx={{ flexGrow: 1 }}
                autoFocus={adSearchInput.length > 0}
              />
            </Box>
            
            {adSearchInput && (
              <Button
                variant="outlined"
                onClick={handleAdSearchClear}
                sx={{ minWidth: 80 }}
              >
                Effacer
              </Button>
            )}
            
            {adSearchTerm && (
              <Typography variant="caption" color="text.secondary">
                {filteredAdsTotal} résultats
              </Typography>
            )}
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Image</TableCell>
                  <TableCell>Titre</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>URL de destination</TableCell>
                  <TableCell>Date de début</TableCell>
                  <TableCell>Date de fin</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 3 ? (
                  // Skeleton pour le chargement
                  Array.from({ length: adRowsPerPage }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell>
                        <Skeleton variant="rectangular" width={50} height={50} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={150} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={200} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={80} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={100} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={100} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  filteredAdsData.map((ad) => (
                    <TableRow key={ad.id}>
                      <TableCell>
                        <img
                          src={(() => {
                            // Gérer la migration depuis imageUrl vers images
                            if (ad.images && Array.isArray(ad.images) && ad.images.length > 0) {
                              return ad.images[0];
                            }
                            return ad.imageUrl || '/img/no_media.jpg';
                          })()}
                          alt={ad.title}
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: 'cover',
                            borderRadius: 4
                          }}
                          onError={(e) => {
                            e.target.src = '/img/no_media.jpg';
                          }}
                        />
                      </TableCell>
                      <TableCell>{ad.title}</TableCell>
                      <TableCell>
                        {ad.description ? (
                          ad.description.length > 50 
                            ? `${ad.description.substring(0, 50)}...` 
                            : ad.description
                        ) : '-'}
                      </TableCell>
                      <TableCell>
                        {ad.targetUrl ? (
                          <a 
                            href={ad.targetUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: '#1976d2', textDecoration: 'none' }}
                          >
                            Lien
                          </a>
                        ) : '-'}
                      </TableCell>
                      <TableCell>
                        {ad.startDate ? new Date(ad.startDate).toLocaleDateString() : '-'}
                      </TableCell>
                      <TableCell>
                        {ad.endDate ? new Date(ad.endDate).toLocaleDateString() : '-'}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={ad.isActive ? 'Active' : 'Inactive'}
                          color={ad.isActive ? 'success' : 'default'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            onClick={() => toggleAdStatus(ad.id, !ad.isActive, ad.title)}
                            color={ad.isActive ? 'default' : 'success'}
                            title={ad.isActive ? 'Désactiver l\'annonce' : 'Activer l\'annonce'}
                          >
                            {ad.isActive ? <Block /> : <CheckCircle />}
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedAd(ad);
                              setAdModalOpen(true);
                            }}
                            color="primary"
                            title="Modifier l'annonce"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => deleteAd(ad.id, ad.title)}
                            color="error"
                            title="Supprimer l'annonce"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={filteredAdsTotal}
            page={adPage}
            onPageChange={handleAdPageChange}
            rowsPerPage={adRowsPerPage}
            onRowsPerPageChange={handleAdRowsPerPageChange}
            labelRowsPerPage="Lignes par page:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
          />
        </TabPanel>

        {/* Onglet Catégories */}
        <TabPanel value={activeTab} index={4}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box>
              <Typography variant="h6">Gestion des Catégories</Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => {
                setSelectedCategory(null);
                setCategoryModalOpen(true);
              }}
            >
              Ajouter une catégorie
            </Button>
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Code</TableCell>
                  <TableCell>Libellé</TableCell>
                  <TableCell>Statut</TableCell>
                 {/* <TableCell>Nombre de produits</TableCell> */}
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 4 ? (
                  // Skeleton pour le chargement
                  Array.from({ length: 10 }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell>
                        <Skeleton variant="text" width={100} height={20} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={150} height={20} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Skeleton variant="rectangular" width={40} height={20} sx={{ borderRadius: 10 }} />
                          <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Skeleton variant="circular" width={40} height={40} />
                          <Skeleton variant="circular" width={40} height={40} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  (categories || []).map((categorie) => (
                    <TableRow key={categorie.id}>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                          {categorie.code}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {categorie.libelle}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Switch
                            checked={localCategoryStatuses.get(categorie.id) ?? (categorie.statut ?? false)}
                            disabled={togglingCategories.has(categorie.id)}
                            onChange={async () => {
                              const currentStatus = localCategoryStatuses.get(categorie.id) ?? (categorie.statut ?? false);
                              const newStatus = !currentStatus;
                              const actionText = newStatus ? 'activée' : 'désactivée';
                              
                              // Mettre à jour l'état local immédiatement
                              setLocalCategoryStatuses(prev => new Map(prev).set(categorie.id, newStatus));
                              
                              // Ajouter la catégorie à l'état de chargement
                              setTogglingCategories(prev => new Set(prev).add(categorie.id));
                              
                              try {
                                const response = await categorieService.toggleCategoryStatus(categorie.id);
                                showNotification(
                                  `Catégorie "${categorie.libelle}" ${actionText} avec succès`
                                );
                                // Mettre à jour l'état local avec la réponse de l'API
                                setLocalCategoryStatuses(prev => {
                                  const newMap = new Map(prev);
                                  newMap.set(categorie.id, response.categorie.statut);
                                  return newMap;
                                });
                              } catch (error) {
                                console.error('Erreur lors du changement de statut:', error);
                                showNotification(
                                  error.response?.data?.message || 'Erreur lors de la modification du statut',
                                  'error'
                                );
                                // Revenir à l'état précédent en cas d'erreur
                                setLocalCategoryStatuses(prev => {
                                  const newMap = new Map(prev);
                                  newMap.delete(categorie.id);
                                  return newMap;
                                });
                              } finally {
                                // Retirer la catégorie de l'état de chargement
                                setTogglingCategories(prev => {
                                  const newSet = new Set(prev);
                                  newSet.delete(categorie.id);
                                  return newSet;
                                });
                              }
                            }}
                            color="primary"
                            size="small"
                            title={categorie.statut ? 'Désactiver la catégorie' : 'Activer la catégorie'}
                          />
                          <Chip
                            label={(localCategoryStatuses.get(categorie.id) ?? categorie.statut) ? 'Actif' : 'Inactif'}
                            color={(localCategoryStatuses.get(categorie.id) ?? categorie.statut) ? 'success' : 'default'}
                            size="small"
                            variant="outlined"
                          />
                        </Box>
                      </TableCell>
                      {/*<TableCell>
                        <Typography variant="body2">
                          {categorie._count?.products || 0} produit(s)
                        </Typography>
                      </TableCell>*/}
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedCategory(categorie);
                              setCategoryModalOpen(true);
                            }}
                            title="Modifier la catégorie"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => deleteCategory(categorie.id, categorie.libelle)}
                            color="error"
                            title="Supprimer la catégorie"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {categories.length === 0 && !loading && (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="text.secondary">
                Aucune catégorie trouvée
              </Typography>
            </Box>
          )}
        </TabPanel>

        {/* Onglet Services */}
        <TabPanel value={activeTab} index={5}>
          <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={showCategorieServicesList}
                  onChange={(e) => setShowCategorieServicesList(e.target.checked)}
                  color="primary"
                />
              }
              label="Afficher la liste des catégories de services"
            />
          </Box>
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Gestion des Services</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Gérez les services et leurs catégories
            </Typography>
          </Box>

          {/* Sous-section: Catégories de Services */}
          {showCategorieServicesList && (
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">Catégories de Services</Typography>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => {
                  setSelectedCategorieService(null);
                  setCategorieServiceModalOpen(true);
                }}
              >
                Ajouter une catégorie
              </Button>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Code</TableCell>
                    <TableCell>Libellé</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Statut</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {categorieServices.map((cat) => (
                    <TableRow key={cat.id}>
                      <TableCell>
                        <Chip label={cat.code} color="primary" size="small" variant="outlined" />
                      </TableCell>
                      <TableCell>{cat.libelle}</TableCell>
                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {cat.description || '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={cat.statut ? 'Actif' : 'Inactif'}
                          color={cat.statut ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedCategorieService(cat);
                              setCategorieServiceModalOpen(true);
                            }}
                            title="Modifier la catégorie de service"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={async () => {
                              try {
                                await adminService.deleteCategorieService(cat.id);
                                showNotification('Catégorie supprimée avec succès');
                                loadCategorieServices();
                              } catch (err) {
                                showNotification('Erreur lors de la suppression', 'error');
                              }
                            }}
                            title="Supprimer la catégorie de service"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          )}

          {/* Sous-section: Services */}
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">Services</Typography>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => {
                  setSelectedService(null);
                  setServiceModalOpen(true);
                }}
              >
                Ajouter un service
              </Button>
            </Box>

            {/* Zone de recherche style navbar pour les services */}
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleServiceSearch();
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#f5f5f5',
                  borderRadius: 2,
                  px: 2,
                  py: 0.5,
                  width: 400,
                  '&:hover': {
                    backgroundColor: '#eeeeee'
                  },
                  '&:focus-within': {
                    backgroundColor: 'white',
                    boxShadow: '0 0 0 2px #1976d2'
                  }
                }}
              >
                <Search sx={{ color: 'text.secondary', mr: 1 }} />
                <InputBase
                  placeholder="Rechercher par titre, catégorie, utilisateur ou boutique..."
                  value={serviceSearchInput}
                  onChange={(e) => setServiceSearchInput(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleServiceSearch();
                    }
                  }}
                  sx={{ flexGrow: 1 }}
                  autoFocus={serviceSearchInput.length > 0}
                />
              </Box>
              
              {serviceSearchInput && (
                <Button
                  variant="outlined"
                  onClick={handleServiceSearchClear}
                  sx={{ minWidth: 80 }}
                >
                  Effacer
                </Button>
              )}
              
              {serviceSearchTerm && (
                <Typography variant="caption" color="text.secondary">
                  {filteredServicesTotal} résultat(s)
                </Typography>
              )}
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nom</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Prix</TableCell>
                    <TableCell>Utilisateur</TableCell>
                    <TableCell>Boutique</TableCell>
                    <TableCell>Catégories</TableCell>
                    <TableCell>Statut</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && activeTab === 5 ? (
                    // Skeleton pour le chargement
                    Array.from({ length: serviceRowsPerPage }).map((_, index) => (
                      <TableRow key={`skeleton-${index}`}>
                        <TableCell>
                          <Skeleton variant="text" width={150} height={20} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={200} height={20} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={100} height={20} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 1 }} />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                            <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Skeleton variant="circular" width={40} height={40} />
                            <Skeleton variant="circular" width={40} height={40} />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    filteredServicesData.map((service) => (
                      <TableRow key={service.id}>
                        <TableCell>
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                            {service.name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 200 }}>
                            {service.description || '-'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          {service.price ? `${parseFloat(service.price).toLocaleString('fr-FR')} FCFA` : '-'}
                        </TableCell>
                        <TableCell>
                          {service.user ? (
                            <Chip label={service.user.name} size="small" />
                          ) : (
                            <Typography variant="body2" color="text.secondary">-</Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          {service.boutique ? (
                            <Chip label={service.boutique.name} size="small" color="primary" />
                          ) : (
                            <Typography variant="body2" color="text.secondary">-</Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                            {service.categories && service.categories.length > 0 ? (
                              service.categories.map((sc) => (
                                <Chip
                                  key={sc.id}
                                  label={sc.categorieService?.libelle || sc.libelle || 'N/A'}
                                  size="small"
                                  variant="outlined"
                                />
                              ))
                            ) : (
                              <Typography variant="body2" color="text.secondary">-</Typography>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={service.isActive ? 'Actif' : 'Inactif'}
                            color={service.isActive ? 'success' : 'error'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedService(service);
                                setServiceModalOpen(true);
                              }}
                              title="Modifier le service"
                            >
                              <Edit />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={async () => {
                                try {
                                  await adminService.deleteService(service.id);
                                  showNotification('Service supprimé avec succès');
                                  loadServices();
                                } catch (err) {
                                  showNotification('Erreur lors de la suppression', 'error');
                                }
                              }}
                              title="Supprimer le service"
                            >
                              <Delete />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={filteredServicesTotal}
              rowsPerPage={serviceRowsPerPage}
              page={servicePage}
              onPageChange={(e, newPage) => setServicePage(newPage)}
              onRowsPerPageChange={(e) => {
                setServiceRowsPerPage(parseInt(e.target.value, 10));
                setServicePage(0);
              }}
              labelRowsPerPage="Lignes par page:"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
            />
          </Box>
        </TabPanel>

        {/* Onglet Formules d'Abonnement */}
        <TabPanel value={activeTab} index={6}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box>
              <Typography variant="h6">Gestion des Formules d'Abonnement</Typography>
              <Typography variant="body2" color="text.secondary">
                {subscriptionPlanTotal} formule(s) d'abonnement disponible(s)
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setSubscriptionPlanModalOpen(true)}
            >
              Ajouter une formule
            </Button>
          </Box>

          {/* Zone de recherche style navbar pour les formules d'abonnement */}
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubscriptionPlanSearch();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                px: 2,
                py: 0.5,
                width: 400,
                '&:hover': {
                  backgroundColor: '#eeeeee'
                },
                '&:focus-within': {
                  backgroundColor: 'white',
                  boxShadow: '0 0 0 2px #1976d2'
                }
              }}
            >
              <Search sx={{ color: 'text.secondary', mr: 1 }} />
              <InputBase
                placeholder="Rechercher par code, intitulé ou description..."
                value={subscriptionPlanSearchInput}
                onChange={(e) => setSubscriptionPlanSearchInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSubscriptionPlanSearch();
                  }
                }}
                sx={{ flexGrow: 1 }}
                autoFocus={subscriptionPlanSearchInput.length > 0}
              />
            </Box>
            
            {subscriptionPlanSearchInput && (
              <Button
                variant="outlined"
                onClick={handleSubscriptionPlanSearchClear}
                sx={{ minWidth: 80 }}
              >
                Effacer
              </Button>
            )}
            
            {subscriptionPlanSearchTerm && (
              <Typography variant="caption" color="text.secondary">
                {filteredSubscriptionPlansTotal} résultat(s)
              </Typography>
            )}
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Code</TableCell>
                  <TableCell>Libellé</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Prix</TableCell>
                  <TableCell>Produits</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 6 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  (filteredSubscriptionPlansData || []).map((plan) => (
                    <TableRow key={plan.id}>
                      <TableCell>
                        <Chip
                          label={plan.code}
                          color="primary"
                          size="small"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                          {plan.libelle}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {plan.description}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                          {plan.prix ? `${plan.prix} FCFA` : 'Non défini'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                          {plan.nombreProduit || 0}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={plan.statut ? 'Actif' : 'Inactif'}
                          color={plan.statut ? 'success' : 'error'}
                          size="small"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton 
                            onClick={() => {
                              setSelectedSubscriptionPlan(plan);
                              setSubscriptionPlanModalOpen(true);
                            }}
                            color="primary"
                            title="Modifier la formule"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton 
                            onClick={() => deleteSubscriptionPlan(plan.id, plan.libelle)}
                            color="error"
                            title="Supprimer la formule"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredSubscriptionPlansTotal}
            rowsPerPage={subscriptionPlanRowsPerPage}
            page={subscriptionPlanPage}
            onPageChange={handleSubscriptionPlanPageChange}
            onRowsPerPageChange={handleSubscriptionPlanRowsPerPageChange}
            labelRowsPerPage="Lignes par page:"
            labelDisplayedRows={({ from, to, count }) => 
              `${from}-${to} sur ${count !== -1 ? count : `plus de ${to}`}`
            }
          />
        </TabPanel>

        {/* Onglet Abonnements */}
        <TabPanel value={activeTab} index={7}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box>
              <Typography variant="h6">Gestion des Abonnements</Typography>
              <Typography variant="body2" color="text.secondary">
                {subscriptionTotal} abonnement(s) attribué(s)
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setSubscriptionModalOpen(true)}
            >
              Attribuer un abonnement
            </Button>
          </Box>

          {/* Zone de recherche style navbar pour les abonnements */}
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubscriptionSearch();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                px: 2,
                py: 0.5,
                width: 400,
                '&:hover': {
                  backgroundColor: '#eeeeee'
                },
                '&:focus-within': {
                  backgroundColor: 'white',
                  boxShadow: '0 0 0 2px #1976d2'
                }
              }}
            >
              <Search sx={{ color: 'text.secondary', mr: 1 }} />
              <InputBase
                placeholder="Rechercher par utilisateur, formule, statut..."
                value={subscriptionSearchInput}
                onChange={(e) => setSubscriptionSearchInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSubscriptionSearch();
                  }
                }}
                sx={{ flexGrow: 1 }}
                autoFocus={subscriptionSearchInput.length > 0}
              />
            </Box>
            
            {subscriptionSearchInput && (
              <Button
                variant="outlined"
                onClick={handleSubscriptionSearchClear}
                sx={{ minWidth: 80 }}
              >
                Effacer
              </Button>
            )}
            
            {subscriptionSearchTerm && (
              <Typography variant="caption" color="text.secondary">
                {filteredSubscriptionsTotal} résultat(s)
              </Typography>
            )}
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Utilisateur</TableCell>
                  <TableCell>Formule</TableCell>
                  <TableCell>Prix</TableCell>
                  <TableCell>Période</TableCell>
                  <TableCell>Informations de paiement</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && activeTab === 7 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  (filteredSubscriptionsData || []).map((subscription) => (
                    <TableRow key={subscription.id}>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {subscription.user?.name || 'N/A'}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {subscription.user?.email || subscription.user?.phone || 'N/A'}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {subscription.formule?.libelle || 'N/A'}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {subscription.formule?.code || 'N/A'}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                          {subscription.formule?.prix || 0} FCFA
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2">
                            Début: {subscription.dateDebut ? new Date(subscription.dateDebut).toLocaleDateString() : 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            Fin: {subscription.dateFin ? new Date(subscription.dateFin).toLocaleDateString() : 'N/A'}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {subscription.referenceTransaction ? (
                          <Box>
                            <Typography variant="caption" color="text.secondary" display="block">
                              Réf: {subscription.referenceTransaction}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block">
                              {subscription.mode || 'N/A'} - {subscription.montant ? `${parseFloat(subscription.montant).toLocaleString('fr-FR')} FCFA` : 'N/A'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block">
                              {subscription.numeroTelephone || 'N/A'}
                            </Typography>
                            {subscription.dateTransaction && (
                              <Typography variant="caption" color="text.secondary" display="block">
                                {new Date(subscription.dateTransaction).toLocaleDateString('fr-FR')}
                              </Typography>
                            )}
                          </Box>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            Non renseigné
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            subscription.statut === 'actif' ? 'Actif' :
                            subscription.statut === 'expiré' ? 'Expiré' :
                            'Inactif'
                          }
                          color={
                            subscription.statut === 'actif' ? 'success' :
                            subscription.statut === 'expiré' ? 'warning' :
                            'error'
                          }
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton 
                            onClick={() => {
                              setSelectedSubscription(subscription);
                              setSubscriptionModalOpen(true);
                            }}
                            color="primary"
                            title="Modifier l'abonnement"
                          >
                            <Edit />
                          </IconButton>
                          <IconButton 
                            onClick={async () => {
                              try {
                                const response = await subscriptionService.toggleSubscriptionStatus(subscription.id);
                                const newStatus = response.data?.statut || subscription.statut;
                                let message = '';
                                if (newStatus === 'actif') {
                                  message = subscription.statut === 'expiré' 
                                    ? 'Abonnement réactivé avec succès' 
                                    : 'Abonnement activé avec succès';
                                } else {
                                  message = 'Abonnement désactivé avec succès';
                                }
                                showNotification(message);
                                loadSubscriptions();
                                loadPendingApprovals(); // Mettre à jour le badge des abonnements en attente
                              } catch (err) {
                                showNotification(err.response?.data?.message || 'Erreur lors de la modification du statut', 'error');
                              }
                            }}
                            color={
                              subscription.statut === 'actif' ? 'error' :
                              subscription.statut === 'expiré' ? 'success' :
                              'success'
                            }
                            title={
                              subscription.statut === 'actif' ? 'Désactiver l\'abonnement' :
                              subscription.statut === 'expiré' ? 'Réactiver l\'abonnement' :
                              'Activer l\'abonnement'
                            }
                          >
                            {subscription.statut === 'actif' ? <Block /> : <CheckCircle />}
                          </IconButton>
                          <IconButton 
                            onClick={() => deleteSubscription(subscription.id, subscription.user?.name)}
                            color="error"
                            title="Supprimer l'abonnement"
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredSubscriptionsTotal}
            rowsPerPage={subscriptionRowsPerPage}
            page={subscriptionPage}
            onPageChange={handleSubscriptionPageChange}
            onRowsPerPageChange={handleSubscriptionRowsPerPageChange}
            labelRowsPerPage="Lignes par page:"
            labelDisplayedRows={({ from, to, count }) => 
              `${from}-${to} sur ${count !== -1 ? count : `plus de ${to}`}`
            }
          />
        </TabPanel>

        {/* Onglet Avis */}
        <TabPanel value={activeTab} index={8}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Gestion des Avis
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Gérez et validez les avis des utilisateurs sur les produits et boutiques.
            </Typography>
          </Box>

          {/* Zone de recherche et filtres pour les avis */}
          <Box sx={{ mb: 3 }}>
            {/* Zone de recherche textuelle */}
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  setReviewSearchTerm(reviewSearchInput);
                  setReviewPage(0);
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#f5f5f5',
                  borderRadius: 2,
                  px: 2,
                  py: 0.5,
                  width: 400,
                  '&:hover': {
                    backgroundColor: '#eeeeee'
                  },
                  '&:focus-within': {
                    backgroundColor: 'white',
                    boxShadow: '0 0 0 2px #1976d2'
                  }
                }}
              >
                <Search sx={{ color: 'text.secondary', mr: 1 }} />
                <InputBase
                  placeholder="Rechercher par commentaire, utilisateur, produit ou boutique..."
                  value={reviewSearchInput}
                  onChange={(e) => setReviewSearchInput(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      setReviewSearchTerm(reviewSearchInput);
                      setReviewPage(0);
                    }
                  }}
                  sx={{ flexGrow: 1 }}
                  autoFocus={reviewSearchInput.length > 0}
                />
              </Box>
              
              {reviewSearchInput && (
                <Button
                  variant="contained"
                  startIcon={<Search />}
                  onClick={() => {
                    setReviewSearchTerm(reviewSearchInput);
                    setReviewPage(0);
                  }}
                  sx={{ minWidth: 100 }}
                >
                  Rechercher
                </Button>
              )}
              
              {reviewSearchInput && (
                <Button
                  variant="outlined"
                  onClick={() => {
                    setReviewSearchInput('');
                    setReviewSearchTerm('');
                    setReviewPage(0);
                  }}
                  sx={{ minWidth: 80 }}
                >
                  Effacer
                </Button>
              )}
              
              {reviewSearchTerm && (
                <Typography variant="caption" color="text.secondary">
                  {reviewTotal} résultats
                </Typography>
              )}
            </Box>
            
            {/* Filtres par listes déroulantes */}
            <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 2 }}>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="review-status-filter-label">Statut</InputLabel>
                <Select
                  labelId="review-status-filter-label"
                  value={reviewIsActiveFilter}
                  label="Statut"
                  onChange={(e) => {
                    setReviewIsActiveFilter(e.target.value);
                    setReviewPage(0);
                  }}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="false">En attente</MenuItem>
                  <MenuItem value="true">Validés</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="review-type-filter-label">Type</InputLabel>
                <Select
                  labelId="review-type-filter-label"
                  value={reviewTypeFilter}
                  label="Type"
                  onChange={(e) => {
                    setReviewTypeFilter(e.target.value);
                    setReviewPage(0);
                  }}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="PRODUCT">Produit</MenuItem>
                  <MenuItem value="BOUTIQUE">Boutique</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </Box>

          {/* Table des avis */}
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Utilisateur</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Objet</TableCell>
                  <TableCell>Note</TableCell>
                  <TableCell>Commentaire</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Box sx={{ py: 3 }}>
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : reviews.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>
                        Aucun avis trouvé
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  reviews.map((review) => (
                    <TableRow key={review.id}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Avatar
                            src={review.reviewer?.profilePhoto}
                            sx={{ width: 32, height: 32 }}
                          >
                            {review.reviewer?.name?.charAt(0)?.toUpperCase()}
                          </Avatar>
                          <Typography variant="body2">
                            {review.reviewer?.name || 'Utilisateur inconnu'}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={review.reviewType === 'PRODUCT' ? 'Produit' : 'Boutique'}
                          size="small"
                          color={review.reviewType === 'PRODUCT' ? 'primary' : 'secondary'}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {review.product?.name || review.boutique?.name || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="body2" fontWeight="bold">
                            {review.rating}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            /5
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {review.isPendingModification && review.originalReview ? (
                          <Box sx={{ maxWidth: 400 }}>
                            <Box sx={{ mb: 1, p: 1, bgcolor: 'error.light', borderRadius: 1 }}>
                              <Typography variant="caption" color="error.dark" fontWeight="bold" sx={{ mb: 0.5, display: 'block' }}>
                                Ancien commentaire (actuellement affiché) :
                              </Typography>
                              <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                                {review.originalReview.comment || 'Aucun commentaire'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                Note: {review.originalReview.rating}/5
                              </Typography>
                            </Box>
                            <Box sx={{ p: 1, bgcolor: 'success.light', borderRadius: 1 }}>
                              <Typography variant="caption" color="success.dark" fontWeight="bold" sx={{ mb: 0.5, display: 'block' }}>
                                Nouveau commentaire (modification proposée) :
                              </Typography>
                              <Typography variant="body2">
                                {review.comment || 'Aucun commentaire'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                Note: {review.rating}/5
                              </Typography>
                            </Box>
                          </Box>
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              maxWidth: 300,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {review.comment || 'Aucun commentaire'}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Stack spacing={0.5}>
                          <Chip
                            label={review.isActive ? 'Validé' : 'En attente'}
                            size="small"
                            color={review.isActive ? 'success' : 'warning'}
                          />
                          {review.isPendingModification && (
                            <Chip
                              label="Modification"
                              size="small"
                              color="info"
                              variant="outlined"
                            />
                          )}
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {new Date(review.createdAt).toLocaleDateString('fr-FR')}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                          {!review.isActive && (
                            <IconButton
                              size="small"
                              color="success"
                              onClick={() => {
                                const message = review.isPendingModification
                                  ? `Êtes-vous sûr de vouloir valider cette modification ? L'ancien commentaire sera remplacé par le nouveau.`
                                  : `Êtes-vous sûr de vouloir valider cet avis ?`;
                                openConfirmationModal(
                                  review.isPendingModification ? 'Valider la modification' : 'Valider l\'avis',
                                  message,
                                  async () => {
                                    try {
                                      await adminService.approveReview(review.id);
                                      showNotification(
                                        review.isPendingModification 
                                          ? 'Modification validée avec succès' 
                                          : 'Avis validé avec succès', 
                                        'success'
                                      );
                                      // Mettre à jour le compteur en décrémentant
                                      setPendingReviewsCount(prev => Math.max(0, prev - 1));
                                      loadReviews();
                                    } catch (error) {
                                      showNotification('Erreur lors de la validation', 'error');
                                      throw error;
                                    }
                                  }
                                );
                              }}
                              title="Valider l'avis"
                            >
                              <CheckCircle />
                            </IconButton>
                          )}
                          {review.isActive && (
                            <IconButton
                              size="small"
                              color="warning"
                              onClick={() => {
                                openConfirmationModal(
                                  'Rejeter l\'avis',
                                  `Êtes-vous sûr de vouloir rejeter cet avis ? Il ne sera plus visible publiquement.`,
                                  async () => {
                                    try {
                                      await adminService.rejectReview(review.id);
                                      showNotification('Avis rejeté avec succès', 'success');
                                      // Mettre à jour le compteur si c'était un commentaire en attente
                                      if (!review.isActive) {
                                        setPendingReviewsCount(prev => Math.max(0, prev - 1));
                                      }
                                      loadReviews();
                                    } catch (error) {
                                      showNotification('Erreur lors du rejet', 'error');
                                      throw error;
                                    }
                                  }
                                );
                              }}
                              title="Rejeter l'avis"
                            >
                              <Block />
                            </IconButton>
                          )}
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => {
                              openConfirmationModal(
                                'Supprimer l\'avis',
                                `Êtes-vous sûr de vouloir supprimer définitivement cet avis ? Cette action est irréversible.`,
                                async () => {
                                  try {
                                    await adminService.deleteReview(review.id);
                                    showNotification('Avis supprimé avec succès', 'success');
                                    // Mettre à jour le compteur si c'était un commentaire en attente
                                    if (!review.isActive) {
                                      setPendingReviewsCount(prev => Math.max(0, prev - 1));
                                    }
                                    loadReviews();
                                  } catch (error) {
                                    showNotification('Erreur lors de la suppression', 'error');
                                    throw error;
                                  }
                                },
                                'Supprimer',
                                'error'
                              );
                            }}
                            title="Supprimer l'avis"
                          >
                            <Delete />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={reviewTotal}
              page={reviewPage}
              onPageChange={(event, newPage) => {
                setReviewPage(newPage);
              }}
              rowsPerPage={reviewRowsPerPage}
              onRowsPerPageChange={(event) => {
                setReviewRowsPerPage(parseInt(event.target.value, 10));
                setReviewPage(0);
              }}
              rowsPerPageOptions={[5, 10, 20, 50]}
              labelRowsPerPage="Lignes par page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} sur ${count !== -1 ? count : `plus de ${to}`}`
              }
            />
          </TableContainer>
        </TabPanel>

        {/* Onglet Approbation */}
        <TabPanel value={activeTab} index={9}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Gestion des approbations
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Configurez les paramètres d'approbation pour contrôler la modération des contenus sur votre plateforme.
            </Typography>
          </Box>

          {/* Paramètres d'Approbation */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Actions rapides
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        if (window.confirm(
                          'Êtes-vous sûr de vouloir désactiver TOUTES les approbations ?\n\n' +
                          'Cela va :\n' +
                          '• Permettre la publication automatique de tous les contenus\n' +
                          '• Désactiver complètement la modération\n' +
                          '• Rendre le site entièrement ouvert'
                        )) {
                          handleDisableAllApprovals();
                        }
                      }}
                      disabled={loading}
                    >
                      Tout désactiver
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        if (window.confirm(
                          'Remettre tous les paramètres par défaut ?\n\n' +
                          'Cela va :\n' +
                          '• Réactiver toutes les approbations obligatoires\n' +
                          '• Remettre le système de modération complet'
                        )) {
                          handleResetToDefault();
                        }
                      }}
                      disabled={loading}
                    >
                      Par défaut
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
{/* 
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Mode de Modération
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box>
                      <Typography variant="body1" fontWeight="medium">
                        Approbations Actives
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {Object.values(approvalSettings).filter(Boolean).length} sur {Object.keys(approvalSettings).length}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid> */}
          </Grid>

          {/* Paramètres Détaillés */}
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Paramètres détaillés | Approbations actives : {Object.values(approvalSettings).filter(Boolean).length} sur {Object.keys(approvalSettings).length}
          </Typography>
          
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">Approbation des produits</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {approvalSettings.products 
                          ? 'Les nouveaux produits nécessitent une validation'
                          : 'Les nouveaux produits sont automatiquement approuvés'
                        }
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={approvalSettings.products}
                          onChange={(e) => handleToggleApproval('products', e.target.checked)}
                          disabled={loading}
                        />
                      }
                      label=""
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">Approbation des boutiques</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {approvalSettings.boutiques 
                          ? 'Les nouvelles boutiques nécessitent une validation'
                          : 'Les nouvelles boutiques sont automatiquement approuvées'
                        }
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={approvalSettings.boutiques}
                          onChange={(e) => handleToggleApproval('boutiques', e.target.checked)}
                          disabled={loading}
                        />
                      }
                      label=""
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">Approbation des avis</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {approvalSettings.reviews 
                          ? 'Les nouveaux avis nécessitent une validation'
                          : 'Les nouveaux avis sont automatiquement approuvés'
                        }
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={approvalSettings.reviews}
                          onChange={(e) => handleToggleApproval('reviews', e.target.checked)}
                          disabled={loading}
                        />
                      }
                      label=""
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">Approbation des utilisateurs</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {approvalSettings.users 
                          ? 'Les nouveaux utilisateurs nécessitent une validation'
                          : 'Les nouveaux utilisateurs sont automatiquement approuvés'
                        }
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={approvalSettings.users}
                          onChange={(e) => handleToggleApproval('users', e.target.checked)}
                          disabled={loading}
                        />
                      }
                      label=""
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Information sur le fonctionnement */}
          {/* <Card sx={{ mt: 3, bgcolor: 'info.light' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <Warning color="info" />
                <Box>
                  <Typography variant="h6" gutterBottom>
                    Comment ça fonctionne
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    • <strong>Approbation activée :</strong> Les nouveaux contenus vont dans "En Attente" et nécessitent votre validation
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    • <strong>Approbation désactivée :</strong> Les nouveaux contenus sont automatiquement approuvés et visibles immédiatement
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    • <strong>Contenus existants :</strong> Ne sont pas affectés par ces changements
                  </Typography>
                  <Typography variant="body2">
                    • <strong>Sécurité :</strong> Vous pouvez toujours supprimer ou modifier les contenus même en mode ouvert
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card> */}
        </TabPanel>

        {/* Onglet Paramètres */}
        <TabPanel value={activeTab} index={10}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Paramètres de la Plateforme
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Configurez les paramètres généraux de votre plateforme.
            </Typography>
          </Box>

          <Grid container spacing={3}>
              {/* Paramètres de base */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Informations de Base
                    </Typography>
                    
                    <Box sx={{ mb: 3 }}>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Gérez les informations de base de votre plateforme.
                      </Typography>
                      
                      <Button
                        variant="contained"
                        onClick={() => setPlatformSettingsModalOpen(true)}
                        sx={{ mb: 2 }}
                      >
                        Modifier les paramètres
                      </Button>
                      
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" gutterBottom>
                          Nom actuel : {settings.site_name || 'Non défini'}
                        </Typography>
                        <Typography variant="subtitle2">
                          Description actuelle : {settings.site_description || 'Non définie'}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Logo de la plateforme */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Logo de la Plateforme
                    </Typography>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      {settings.site_logo ? (
                        <Box sx={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                          <Box sx={{ position: 'relative', display: 'inline-block' }}>
                            <img 
                              src={settings.site_logo} 
                              alt="Logo actuel" 
                              style={{ 
                                maxWidth: '200px', 
                                maxHeight: '100px', 
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px'
                              }}
                            />
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteIcon('logo')}
                              sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                bgcolor: 'error.main',
                                color: 'white',
                                '&:hover': {
                                  bgcolor: 'error.dark',
                                },
                                zIndex: 1
                              }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Logo actuel
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ 
                          width: '200px', 
                          height: '100px', 
                          border: '2px dashed #ccc', 
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          gap: 1
                        }}>
                          <Typography variant="body2" color="text.secondary">
                            Aucun logo
                          </Typography>
                        </Box>
                      )}
                      
                      <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="logo-upload"
                        type="file"
                        onChange={handleLogoUpload}
                        disabled={false}
                      />
                      <label htmlFor="logo-upload">
                        <Button
                          variant="outlined"
                          component="span"
                          disabled={false}
                          startIcon={<Add />}
                        >
                          {settings.site_logo ? 'Changer le logo' : 'Ajouter un logo'}
                        </Button>
                      </label>
                      
                      <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center' }}>
                        Formats acceptés: JPG, PNG, GIF<br />
                        Taille maximale: 50MB (sera compressé en WebP)<br />
                        Dimensions recommandées: 200x100px
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Favicon */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Favicon
                    </Typography>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      {settings.site_favicon ? (
                        <Box sx={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                          <Box sx={{ position: 'relative', display: 'inline-block' }}>
                            <img 
                              src={settings.site_favicon} 
                              alt="Favicon actuel" 
                              style={{ 
                                width: '32px', 
                                height: '32px', 
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '4px'
                              }}
                            />
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteIcon('favicon')}
                              sx={{
                                position: 'absolute',
                                top: -8,
                                right: -8,
                                bgcolor: 'error.main',
                                color: 'white',
                                width: 24,
                                height: 24,
                                '&:hover': {
                                  bgcolor: 'error.dark',
                                },
                                zIndex: 1
                              }}
                            >
                              <Delete sx={{ fontSize: '14px' }} />
                            </IconButton>
                          </Box>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Favicon actuel
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ 
                          width: '32px', 
                          height: '32px', 
                          border: '2px dashed #ccc', 
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Typography variant="caption" color="text.secondary">
                            Aucun
                          </Typography>
                        </Box>
                      )}
                      
                      <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="favicon-upload"
                        type="file"
                        onChange={(e) => handleIconUpload(e, 'favicon')}
                        disabled={false}
                      />
                      <label htmlFor="favicon-upload">
                        <Button
                          variant="outlined"
                          component="span"
                          disabled={false}
                          startIcon={<Add />}
                        >
                          {settings.site_favicon ? 'Changer le favicon' : 'Ajouter un favicon'}
                        </Button>
                      </label>
                      
                      <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center' }}>
                        Formats acceptés: ICO, PNG, SVG<br />
                        Taille maximale: 1MB<br />
                        Dimensions recommandées: 32x32px ou 16x16px
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Apple Touch Icon */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Apple Touch Icon
                    </Typography>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      {settings.site_apple_touch_icon ? (
                        <Box sx={{ textAlign: 'center', position: 'relative', display: 'inline-block' }}>
                          <Box sx={{ position: 'relative', display: 'inline-block' }}>
                            <img 
                              src={settings.site_apple_touch_icon} 
                              alt="Apple Touch Icon actuel" 
                              style={{ 
                                width: '100px', 
                                height: '100px', 
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px'
                              }}
                            />
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteIcon('apple-touch-icon')}
                              sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                bgcolor: 'error.main',
                                color: 'white',
                                '&:hover': {
                                  bgcolor: 'error.dark',
                                },
                                zIndex: 1
                              }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Apple Touch Icon actuel
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ 
                          width: '142px', 
                          height: '100px', 
                          border: '2px dashed #ccc', 
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Typography variant="body2" color="text.secondary">
                            Aucune icône
                          </Typography>
                        </Box>
                      )}
                      
                      <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="apple-icon-upload"
                        type="file"
                        onChange={(e) => handleIconUpload(e, 'apple-touch-icon')}
                        disabled={false}
                      />
                      <label htmlFor="apple-icon-upload">
                        <Button
                          variant="outlined"
                          component="span"
                          disabled={false}
                          startIcon={<Add />}
                        >
                          {settings.site_apple_touch_icon ? 'Changer l\'icône' : 'Ajouter une icône'}
                        </Button>
                      </label>
                      
                      <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center' }}>
                        Formats acceptés: PNG, JPG<br />
                        Taille maximale: 50MB (sera compressé en WebP)<br />
                        Dimensions recommandées: 192x192px ou 180x180px
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Paramètres de fonctionnement */}
              {/* <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Paramètres de Fonctionnement
                    </Typography>
                    
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={settings.maintenance_mode || false}
                              onChange={(e) => {
                                const newValue = e.target.checked;
                                adminService.updateSystemSetting('maintenance_mode', newValue);
                              }}
                              disabled={false}
                            />
                          }
                          label={
                            <Box>
                              <Typography variant="body1">
                                Mode Maintenance
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Désactive l'accès public au site
                              </Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={settings.registration_enabled || true}
                              onChange={(e) => {
                                const newValue = e.target.checked;
                                adminService.updateSystemSetting('registration_enabled', newValue);
                              }}
                              disabled={false}
                            />
                          }
                          label={
                            <Box>
                              <Typography variant="body1">
                                Inscription Ouverte
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Permet aux nouveaux utilisateurs de s'inscrire
                              </Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={settings.email_verification_required || true}
                              onChange={(e) => {
                                const newValue = e.target.checked;
                                adminService.updateSystemSetting('email_verification_required', newValue);
                              }}
                              disabled={false}
                            />
                          }
                          label={
                            <Box>
                              <Typography variant="body1">
                                Vérification Email Obligatoire
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Exige la vérification email pour activer les comptes
                              </Typography>
                            </Box>
                          }
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid> */}

              {/* Informations sur l'impact */}
              {/* <Grid item xs={12}>
                <Card sx={{ bgcolor: 'info.light', color: 'info.contrastText' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Warning />
                      Impact des Paramètres
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      Les modifications de ces paramètres affectent directement l'expérience utilisateur :
                    </Typography>
                    <Typography variant="body2" component="div">
                      • <strong>Nom et Description :</strong> Apparaissent dans le header, footer et métadonnées du site<br/>
                      • <strong>Logo :</strong> Affiché dans la navbar et les pages publiques<br/>
                      • <strong>Mode Maintenance :</strong> Affiche une page de maintenance pour tous les visiteurs<br/>
                      • <strong>Inscription :</strong> Contrôle l'accès au formulaire d'inscription<br/>
                      • <strong>Vérification Email :</strong> Détermine si les utilisateurs doivent vérifier leur email
                    </Typography>
                  </CardContent>
                </Card>
              </Grid> */}
            </Grid>
        </TabPanel>
      </Paper>

      {/* Modales */}
      <UserModal
        open={userModalOpen}
        onClose={() => {
          setUserModalOpen(false);
          setSelectedUser(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet utilisateurs
          if (activeTab === 0) {
            reloadCurrentTab();
          }
        }}
        user={selectedUser}
      />

      <BoutiqueModal
        open={boutiqueModalOpen}
        onClose={() => {
          setBoutiqueModalOpen(false);
          setSelectedBoutique(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet boutiques
          if (activeTab === 1) {
            reloadCurrentTab();
          }
        }}
        boutique={selectedBoutique}
      />

      <ProductModal
        open={productModalOpen}
        onClose={() => {
          setProductModalOpen(false);
          setSelectedProduct(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet produits
          if (activeTab === 2) {
            reloadCurrentTab();
          }
        }}
        product={selectedProduct}
      />

      <AdModal
        open={adModalOpen}
        onClose={() => {
          setAdModalOpen(false);
          setSelectedAd(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet annonces
          if (activeTab === 3) {
            reloadCurrentTab();
          }
        }}
        ad={selectedAd}
      />

      <ServiceModal
        open={serviceModalOpen}
        onClose={() => {
          setSelectedService(null);
          setServiceModalOpen(false);
        }}
        onSuccess={() => {
          loadServices();
          loadCategorieServices();
        }}
        service={selectedService}
      />

      <CategorieServiceModal
        open={categorieServiceModalOpen}
        onClose={() => {
          setSelectedCategorieService(null);
          setCategorieServiceModalOpen(false);
        }}
        onSuccess={() => {
          loadCategorieServices();
        }}
        categorieService={selectedCategorieService}
      />

{/* Modal de catégorie */}
<CategoryModal
        open={categorieModalOpen}
        onClose={() => {
          setCategoryModalOpen(false);
          setSelectedCategory(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet catégories
          if (activeTab === 4) {
            reloadCurrentTab();
          }
        }}
        categorie={selectedCategory}
      />
<SubscriptionPlanModal
        open={subscriptionPlanModalOpen}
        onClose={() => {
          setSubscriptionPlanModalOpen(false);
          setSelectedSubscriptionPlan(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet formules d'abonnement (onglet 6)
          if (activeTab === 6) {
            loadSubscriptionPlans();
          }
        }}
        plan={selectedSubscriptionPlan}
      />

      <SubscriptionModal
        open={subscriptionModalOpen}
        onClose={() => {
          setSubscriptionModalOpen(false);
          setSelectedSubscription(null);
        }}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger l'onglet actuel si c'est l'onglet abonnements
          if (activeTab === 7) {
            loadSubscriptions();
          }
        }}
        subscription={selectedSubscription}
      />

      {/* Modal de confirmation */}
      <ConfirmationModal
        open={confirmationModalOpen}
        onClose={closeConfirmationModal}
        onConfirm={handleConfirmAction}
        title={confirmationData.title}
        message={confirmationData.message}
        confirmText={confirmationData.confirmText}
        cancelText="Annuler"
        severity={confirmationData.severity}
        loading={confirmationData.loading}
      />
      {/* Onglet Logs de Sécurité */}
      <TabPanel value={activeTab} index={11}>
        <SecurityLogs />
      </TabPanel>

      <PlatformSettingsModal
        open={platformSettingsModalOpen}
        onClose={() => setPlatformSettingsModalOpen(false)}
        onSuccess={(message) => {
          showNotification(message);
          // Recharger les paramètres
          loadSettings(true);
        }}
      />

      {/* Composant de notification avec auto-dismiss */}
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={clearNotification}
      />
    </Container>
  );
};

export default Admin;
